import { useContext, useEffect, useState, useRef, useCallback } from "react";
import { useAuthStore } from "../../AuthStore/AuthStore";
import { API } from "../../Axios/Axios";
import type { Rule } from 'antd/lib/form';
import {
  GetSectionComponentData,
  GetDocumentTypeData,
  GetAdditionalFields,
  SaveSubmissionData,
  DeleteSubmissionData,
  viewFile,
  updateVerificationAction,
  getInvestmentCycleForVerification,
  updateIsReadFlagForEmp,
  getQueryOnChat
} from "../../Helpers/APIEndpoints/Endpoints";
import {
  base64ToArrayBuffer,
  getBase64FromFilePromise,
} from "../../Helpers/Common/FileHelper";
import { LoaderContext } from "../../Helpers/Context/Context";
import {
  UnorderedListOutlined, PlusOutlined, MinusOutlined, LinkOutlined, PlusCircleOutlined,
  CloseCircleOutlined,
  ExclamationCircleOutlined

} from "@ant-design/icons";
import { FormInput } from "../../Components/FormInputs/FormInputs";
import type { CollapseProps } from "antd";
import {
  Tabs,
  Card,
  Row,
  Col,
  Button,
  Select,
  Dropdown,
  Menu,
  Form,
  InputNumber,
  Collapse,
  Checkbox,
  Radio,
  message,
  Input,
  Modal,
  Divider,
  DatePicker,
  Tooltip,
  Flex
} from "antd";
import TextArea from "antd/es/input/TextArea";
import { FormSelect } from "../../Components/FormSelect";
import { PropaneSharp } from "@mui/icons-material";

import { Upload } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import type { UploadProps } from 'antd';
import FormFileUpload from "../../Components/FormFileUpload";
import { BsThreeDotsVertical } from "react-icons/bs";
import PdfViewer from '../../FileReader/PdfViewer';
import ImageViewer from "../../FileReader/ImageViewer";
import Item from "antd/es/list/Item";
//import * as pdfjsLib from 'pdfjs-dist';
import { useLocation, useNavigate } from "react-router-dom";
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import moment from "moment";
import { color } from "html2canvas/dist/types/css/types/color";
import { isDataScheme } from "pdfjs-dist/types/src/display/display_utils";

import { getDocument } from 'pdfjs-dist';
import ChatBox from "../../Components/Chatbox/ChatBox";
import Title from "antd/lib/typography/Title";


const { TabPane } = Tabs;

type ExpandIconPosition = "start" | "end";

interface IOptions {
  label?: string;
  value?: number | string;
  code?: string;
}

interface IFormData {
  sectionComponent?: IOptions | number;
  sectionComponentText?: IOptions | string;
  documentType?: IOptions | number | null | any;
  documentTypeText?: IOptions | null | string;
  amount?: IOptions | any;
  documents?: IOptions | any;
}
interface IAddFeildData {
  [key: string]: any;
}

const props: UploadProps = {
  name: 'file',
  action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
  headers: {
    authorization: 'authorization-text',
  },
  onChange(info) {
    if (info.file.status !== 'uploading') {
      ////console.log(info.file, info.fileList);
    }
    if (info.file.status === 'done') {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};

const VerificationDashboard = ({ ...props
}: any) => {
  const [form] = Form.useForm();
  //const [form] = useState<any>(props?.form);
  const { state } = useLocation();
  const [requserId, setReqUserId] = useState(state?.userId);
  const [showForm, setShowForm] = useState(false);
  const [userName, setUserName] = useState("");
  const [formData, setFormData] = useState<IFormData>({});
  const [formErrors, setFormErrors] = useState<IFormData>({});
  const [formOptions, setFormOptions] = useState<IFormData>({});
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const { userId, currentRoleId, currentFinancialYearId,currentuserroleList } = useAuthStore();
  const [documentType, setDocumentType] = useState<number | null>(null);
  const [sectionComponentList, setSectionComponentList] = useState([]);
  const [cycleList, setCycleList] = useState<any>([]);
  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);
  // const [collapsibleItems, setCollapsibleItems] = useState<CollapseProps["items"]>([]);
  type ItemType = NonNullable<CollapseProps["items"]>[number];
  const [collapsibleItems, setCollapsibleItems] = useState<ItemType[]>([]);

  const [expandIconPosition] = useState<ExpandIconPosition>("end");
  const [activeKeys, setActiveKeys] = useState<string[]>(["1"]);
  const uploadFileRef = useRef<any>(null);
  const [files, setFiles] = useState<any>([]);
  const [sectionId, setSectionId] = useState(0);
  const [componentId, setComponentId] = useState(0);
  const [configurationId, setConfigurationId] = useState(0);
  const [isAdded, setIsAdded] = useState(false);
  const [remark, setRemark] = useState<string>("");
  const [verfierRemark,setVerifierRemark] = useState<string>("");
  const [amount, setAmount] = useState(0);
  const [investmentCycleId, setInvestmentCycleId] = useState(0);
  const [fileBase64, setFileBase64] = useState<string>("");
  const [fileType, setFileType] = useState<string>("");
  const [newId, setNewId] = useState(0);
  // const DynamicForm = ({ formData, initialValues }) => {
  //   const [form] = Form.useForm();
  //const [arrayToSubmit, setArrayToSubmit] = useState<ISavingData>({});
  const [selectedFiles, setSelectedFiles] = useState<any>([]);
  const [file, setFile] = useState<any>(null);
  const [isPasswordProtected, setIsPasswordProtected] = useState<any>(false);
  const [password, setPassword] = useState<any>('');
  const [showModal, setShowModal] = useState<any>(false);
  const [errorMessage, setErrorMessage] = useState<any>('');
  const [verifiedPassword, setVerifiedPassword] = useState<any>(null);
  const navigate = useNavigate();
  const [isEditable, setIsEditable] = useState<any>(false);
  //const [additionalFieldCopy , setAdditionalFieldCopy] = useState<any>();

  const [isReplicable, setIsReplicable] = useState<any>(false);
  const [isEditClicked, SetIsEditClicked] = useState(false);
  const [isRemoveClicked, setIsRemovedClicked] = useState(false);
  const [currentRmovedId, setCurrentRemovedId] = useState(null);

  const [changedFieldName, setChangedFieldName] = useState("");
  const [changedItemId, setChangedItemId] = useState(0);

  //new 
  const [letPropertyValues, setLetPropertyValues] = useState<any[]>([]);
  const [startDateMap, setStartDateMap] = useState<Record<number, Dayjs | null>>({});
  const [endDateMap, setEndDateMap] = useState<Record<number, Dayjs | null>>({});
  const [isDisable, setIsDisable] = useState<any>(false);
  const [FirstCycleData, setFirstCycleData] = useState<boolean>();
  const [sectionName, setSectionName] = useState<any>();
  const [dateErrors, setDateErrors] = useState<Record<number, string | undefined>>({});

  const [isLocked, setIsLocked] = useState<any>(false);
  const [isShowVerifier,setShowVerifierRemark] = useState<any>(false);
  const [isUndoButtonVisible,setIsUndoButtonVisible] = useState<any>(true);
  const [viewerKey, setViewerKey] = useState(0);
  
  const [JointPropertyValues, setJointPropertyValues] = useState<any[]>([]);
  const [currentSelectedItem, setCurrentSelectedItem] = useState<any>();
  const { confirm } = Modal;
  const [isOpen, setIsOpen] = useState(false);
  const [queryList, setQueryList] = useState<any>([]);
  const [msgCount, setMsgCount] = useState(0);
  const [actionPerformed,setActionPerformed] = useState<any>('');
  const [isApprovedOrRejected,setIsApprovedOrRejectedVisible] = useState(false);
  const [isCurrUserAdminOrSuperAdmin, setisCurrUserAdminOrSuperAdmin] = useState(false);
  const [isFocusedIndex,setFocusedIndex] = useState<any>(0);
  const [employeeSubmissionOgFinalDetailsAdditionlFieldId,setCurrentFieldOgemployeeSubmissionFinalDetailsAdditionlFieldId] = useState("");
  const pdfUrl = "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf";

  const clearFieldErrors = (key: string) => {
    setDateErrors((prev) => ({ ...prev, [key]: undefined }));
  };

 useEffect(() => {
  getCycleCardDetails();

  if (!FirstCycleData || !Array.isArray(cycleList) || cycleList.length === 0) {
    return;
  }

  let selectedCycle: any = null;
  let selectedDetail: any = null;
  let cycleIndex: number | null = null;
  let detailIndex: number | null = null;

  // ---------------- CASE 1: isFocusedIndex is provided ----------------
  if (
    isFocusedIndex !== null &&
    typeof isFocusedIndex === "object" &&
    typeof isFocusedIndex.cycleIndex === "number" &&
    typeof isFocusedIndex.detailIndex === "number"
  ) {
    cycleIndex = isFocusedIndex.cycleIndex;
    detailIndex = isFocusedIndex.detailIndex;

    selectedCycle = cycleList?.[cycleIndex];
    selectedDetail = selectedCycle?.cycleDetails?.[detailIndex];
  }

  // ---------------- CASE 2: fallback to isCurrentCycle ----------------
  if (!selectedDetail) {
    cycleIndex = cycleList.findIndex(item => item.isCurrentCycle);
    if (cycleIndex === -1) cycleIndex = 0;

    selectedCycle = cycleList?.[cycleIndex];
    detailIndex = 0;

    selectedDetail = selectedCycle?.cycleDetails?.[detailIndex];
  }

  // ---------------- FINAL GUARD ----------------
  if (!selectedDetail) return;

    
    if (selectedCycle?.id) {
      setActiveKeys([selectedCycle.id.toString()]);
    }


  console.log('Focused cycleIndex:', cycleIndex, 'detailIndex:', detailIndex);

  setFirstCycleData(false);
  handleFocusedCurrent(selectedDetail, detailIndex);
  handleEdit(selectedDetail, true, detailIndex);

}, [cycleList,isFocusedIndex]);


  // useEffect(()=>{
  //   if(isEditClicked == true)
  //   {
  //     const initialValues: Record<string, any> = {};
  //     cycleList.map((cycle)=>{
  //       if(cycle.isCurrentCycle == true)
  //       {
  //           return{
  //             ...cycle,
  //             cycleDetails:cycle.cycleDetails.map((details)=>{
  //               if(details.isAdditionalFieldFocused == true){

  //                   initialValues["amount"] = details?.amount ?? '';
  //                   initialValues["remark"] = details?.remark ?? '';

  //                   const additionalFieldItems = details?.additionalFieldListV2.map((item: any, index: number) => {
  //                     const fieldKey = `${item.fieldName}-${item.id}-${index}`;
  //                     let valueFromData : any= "";
  //                     if (item.responseType.toLocaleLowerCase() == "choices") {
  //                       valueFromData = item?.[item.fieldName] ? item?.[item.fieldName].split(",") : [];
  //                     }
  //                     else {
  //                       valueFromData = item?.[item.fieldName] ?? "";
  //                     }
  //                     initialValues[fieldKey] = valueFromData;
  //                     });

  //                   // Set form values

  //                   form.setFieldsValue(initialValues);

  //               }
  //             })
  //           }
  //         }
  //     })
  //     ////console.log('intialvalue ==>',initialValues)



  //   }
  // },[isEditClicked])

  useEffect(() => {
    if (isEditClicked) {
      const initialValues: Record<string, any> = {};

      cycleList.forEach((cycle) => {
       // if (cycle.isCurrentCycle) {
          cycle.cycleDetails.forEach((details) => {
            if (details.isAdditionalFieldFocused) {

              initialValues["amount"] = Number(details.amount) ?? 0;
              initialValues["remark"] = details.remark ?? '';
              initialValues["verifierRemark"] = details.verifierRemarks ?? '';

              details.additionalFieldListV2?.forEach((item, index) => {
                const key = `${item.fieldName}-${item.id}-${index}`;
                let value: any = null;

                const responseType = item.responseType?.toLowerCase();
                if (responseType === "choices") {
                  value = item.fieldValue ? item.fieldValue.split(",") : [];
                } else if (responseType === "numeric") {
                  value = Number(item.fieldValue);
                } else if (responseType === "date") {
                  const rawDate = item.fieldValue;
                  const parsed = rawDate ? dayjs(rawDate, "MMM D YYYY hh:mmA") : null;

                  value = parsed?.isValid() ? parsed : null;
                } else {
                  value = item.fieldValue ?? '';
                }

                initialValues[key] = value;
              });
            }
          });
        //}
      });

      ////console.log("initialValues ==> ", initialValues);
      form.setFieldsValue(initialValues);
      SetIsEditClicked(false);
    }
  }, [isEditClicked]);


  // useEffect(() => {
  //   if (isRemoveClicked) {
  //     const initialValues: Record<string, any> = {};

  //     cycleList.forEach((cycle) => {
  //       if (cycle.isCurrentCycle) {
  //         cycle.cycleDetails.forEach((details) => {
  //           if (details.isAdditionalFieldFocused) {

  //             initialValues["amount"] = details.amount ?? '';
  //             initialValues["remark"] = details.remark ?? '';
  //             initialValues["verifierRemark"] = details.verifierRemarks ?? '';

  //             details.additionalFieldListV2?.forEach((item, index) => {
  //               const key = `${item.fieldName}-${item.id}-${index}`;
  //               let value: any = null;

  //               const responseType = item.responseType?.toLowerCase();
  //               if (responseType === "choices") {
  //                 value = item.fieldValue ? item.fieldValue.split(",") : [];
  //               } else if (responseType === "numeric") {
  //                 value = Number(item.fieldValue);
  //               } else if (responseType === "date") {
  //                 const rawDate = item.fieldValue;
  //                 const parsed = dayjs(rawDate);
  //                 value = parsed.isValid() ? parsed : null;
  //               } else {
  //                 value = item.fieldValue ?? '';
  //               }

  //               initialValues[key] = value;
  //             });
  //           }
  //         });
  //       }
  //     });

  //     ////console.log("initialValues ==> ", initialValues);
  //     form.setFieldsValue(initialValues);
  //   }
  // }, [isRemoveClicked]);

  // const getMenu = (item: any) => (

  //   <Menu>
  //     {isEditable && (
  //       <>
  //         <Menu.Item key="1" onClick={() => handleEdit(item, false)}>
  //           Edit
  //         </Menu.Item>
  //         {(item?.status == 'Draft' || item?.status == 'Not Submitted') && (
  //           <Menu.Item key="2"
  //            onClick={(e) =>{
  //             handleDelete(item)
  //             e.domEvent?.stopPropagation();
  //            }
  //           }>
  //             Delete
  //           </Menu.Item>
  //         )
  //         }
  //       </>
  //     )}
  //     <Menu.Item key="3" onClick={() => handleViewDetails(item)}
  //     >
  //       View Details
  //     </Menu.Item>
  //   </Menu>
  // );


  useEffect(() => {
    GetSectionComponent();

    const isAdminOrSuperAdmin = currentuserroleList?.some(role => role.SystemName?.toLowerCase() == "admin"
      || role.SystemName?.toLowerCase() == "superadmin");
    // const hasAdminOrSuperAdmin = currentuserroleList.some(role =>
    //   role.SystemName === 'Admin' || role.SystemName === 'SuperAdmin'
    // );

    setisCurrUserAdminOrSuperAdmin(isAdminOrSuperAdmin);
    //GetDocumentType();
  }, [requserId,actionPerformed]);

  const GetSectionComponent = useCallback(async () => {
    try {

      showLoader();
      // let { data: { data } } = await API.post(GetSectionComponentData, {
      //   FinancialYearId: currentFinancialYearId,
      //   CreatedBy: userId,
      //   UserId: userId,
      //   CategoryType: 'Investment'
      // });
     debugger;
      let { data: { data } } = await API.post(getInvestmentCycleForVerification, {
              FinancialYearId: currentFinancialYearId,
              UserId: requserId,
            });
  
    console.log('res cycle details=========>', data)
      if (data) {
        //console.log('data of response ',data)
        ////console.log('data.sectionComponentList',data.sectionComponentList)
        //setSectionComponentList(data.sectionComponentList)
        // const formattedData = data.sectionComponentList.map((item: { name: string | null; Id: number | null; }) => ({
        //   label: item?.name,
        //   value: item?.Id,
        // }));
        // //console.log('show first one bydefault - ', data.cycleMasterList)

        

        let CycleListWithShowFirst = data?.cycleList?.map((item) => {
          if (item.isCurrentCycle) {
            return {
              ...item,
              cycleDetails: item.cycleDetails.map((cycles, index) => {
                if (index == 0) {
                  // //console.log('show first one cycle - ', cycles)
                  setSectionName(cycles?.sectionName);
                  return {
                    ...cycles,
                    isAdditionalFieldFocused: true,
                  }
                }
                return cycles
              })
            }

          }
          return item;
        })

    // if (fileName?.toLowerCase().endsWith(".pdf")) {
    //       fileType = "pdf";
    //     } else if (
    //       fileName?.toLowerCase().endsWith(".jpg") ||
    //       fileName?.toLowerCase().endsWith(".jpeg") ||
    //       fileName?.toLowerCase().endsWith(".png")
    //     ) {
    //       fileType = "image";
    //     }
    //     setFileType(fileType);
    //     setFileBase64(imagedata);

    //     handleFileClick(fileName,imagedata,filePath);
    
    let fileName = "";
        let fileBase64 = "";
        let filePath = "";


        //console.log('after CycleListWithShowFirst', CycleListWithShowFirst)
        const initialValues: Record<string, any> = {};
        CycleListWithShowFirst.forEach((cycle) => {
          if (cycle.isCurrentCycle) {
            cycle.cycleDetails.forEach((details) => {
              if (details.isAdditionalFieldFocused) {

                console.log('details in foreach',details)
                fileName = details.fileName;
                filePath = details.filePath;

                initialValues["amount"] = details.amount ?? '';
                initialValues["remark"] = details.remark ?? '';
                initialValues["verifierRemark"] = details.verifierRemarks ?? '';

                details.additionalFieldListV2?.forEach((item, index) => {

                  const key = `${item.fieldName}-${item.id}-${index}`;
                  let value: any = null;

                  const responseType = item.responseType?.toLowerCase();
                  if (responseType === "choices") {
                    value = item.fieldValue ? item.fieldValue.split(",") : [];
                  } else if (responseType === "numeric") {
                    value = Number(item.fieldValue);
                  } else if (responseType === "date") {
                    const rawDate = item.fieldValue;
                    const parsed = rawDate ? dayjs(rawDate, "MMM D YYYY hh:mmA") : null;

                    value = parsed?.isValid() ? parsed : null;
                  } else {
                    value = item.fieldValue ?? '';
                  }

                  initialValues[key] = value;
                });
                let isReplicableAllowed = details.additionalFieldListV2?.[0]?.isReplicable ? details.additionalFieldListV2?.[0]?.isReplicable : false;
                // //console.log('isReplicable in GetSectionComponent==>', isReplicableAllowed)
                setIsReplicable(isReplicableAllowed);

              }
            });
          }
        });

        setCycleList(CycleListWithShowFirst);
        setUserName(CycleListWithShowFirst?.[0]?.reqUserName);
        form.setFieldsValue(initialValues);
        setFirstCycleData(true)
        // const firstCycleFromCurrent = data?.cycleMasterList
        // ?.find(item => item.isCurrentCycle)
        // ?.cycleDetails?.[0];

        if (data.cycleList.length > 0) {
          setIsAdded(true);
        }
        // setFormOptions((prev) => {

        //   return {
        //     ...prev,
        //     sectionComponent: formattedData || [],
        //   };
        // });
        setIsEditable(true);

        handleFileClick(fileName,fileBase64,filePath);
      }
    }
    catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      message.error(`Failed to perform GetSectionComponent`);
    } finally {
      hideLoader();
    }
  }, [currentFinancialYearId, requserId,actionPerformed])

  useEffect(() => {
    //GetDocumentType();
  }, [formData?.sectionComponent]);

  
  // useEffect(() => {
  //   //console.log('latest cycle List==>', cycleList)
  // }, [cycleList])


   const deepEqual=(obj1,obj2)=>{

      if (obj1 === obj2) {
          return true;
        }

        if (typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null) {
          return false;
        }

        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);

        if (keys1.length !== keys2.length) {
          return false;
        }

        for (let key of keys1) {
          if (!obj2.hasOwnProperty(key) || !deepEqual(obj1[key], obj2[key])) {
            return false;
          }
        }

        return true;
  }


  // const GetDocumentType = async () => {
  //   try {

  //     showLoader();
  //     const SecData = (sectionComponentList as any[]).filter(
  //       x => x.Id === Number(formData?.sectionComponent)
  //     );

  //     let sectionId = SecData[0]?.sectionId;
  //     setSectionId(sectionId);
  //     let componentId = SecData[0]?.componentId;
  //     setComponentId(componentId);
  //     let configurationId = SecData[0]?.configurationId;
  //     setConfigurationId(configurationId)

  //     let { data: { data } } = await API.post(GetDocumentTypeData, {
  //       FinancialYearId: currentFinancialYearId,
  //       SectionId: sectionId,
  //       ComponentId: componentId,
  //       CategoryType: "Investment",

  //     });

  //     if (data) {
  //       //setDocumentTypeOptions(response.data.data.DocumentTypeList);
  //       const formattedData = data.documentTypeList.map((item: { name: string | null; Id: number | null; }) => ({
  //         label: item.name,
  //         value: item.Id,
  //       }));
  //       setDocumentTypeOptions(formattedData);
  //     }
  //   }
  //   catch (error) {
  //     hideLoader();
  //     console.error("Error:", error);
  //     //console.error("Error:", error.response.data);
  //     message.error(`Failed to perform GetDocumentType`);
  //   } finally {
  //     hideLoader();
  //   }
  // };

  const handleFileChange = async (event: any) => {
    //setFiles([]);
    //const files = event.target.files[0] || null;


    const selectedFile = event.target.files?.[event.target.files.length - 1]; //event.target.files?.[0];
    ////console.log('selectedFile==>', selectedFile)
    if (!selectedFile) {
      setFiles([]);
      message.error("Please select a file.");
      return;
    }

    const fileName = selectedFile.name.toLowerCase();

    if (fileName?.endsWith(".pdf")) {
      const passwordPassed = await handlePasswordCheck(event);
      if (!passwordPassed) {
        console.warn('Password check failed or was cancelled');
        return;
      }
    }
    // const passwordPassed = await handlePasswordCheck(event);
    // if (!passwordPassed) {
    //   console.warn('🔐 Password check failed or was cancelled');
    //   return;
    // }


    const selectedfiles = event.target.files || null;
    ////console.log('Selected file part 2==>', selectedfiles)
    setSelectedFiles(selectedfiles);
    if (!selectedfiles) {
      setFiles([]);
      message.error("Please select a file.");
      return;
    }

    for (let i = 0; i < selectedfiles.length; i++) {
      if (
        !selectedfiles[i].name.endsWith(".jpg") && !selectedfiles[i].name.endsWith(".JPG") &&
        !selectedfiles[i].name.endsWith(".jpeg") && !selectedfiles[i].name.endsWith(".JPEG") &&
        !selectedfiles[i].name.endsWith(".pdf") && !selectedfiles[i].name.endsWith(".PDF") &&
        !selectedfiles[i].name.endsWith(".png") && !selectedfiles[i].name.endsWith(".PNG")) {
        setFiles([]);
        const input = document.getElementById("ATTACHMENT") as HTMLInputElement;
        if (input) {
          input.value = "";
        }
        message.error("Invalid File extension. Please upload only pdf, jpeg, jpg, png files.");
        return;
      }
      else if ((selectedfiles[i].size) / (1024 * 1024) > 2) {
        setFiles([]);
        const input = document.getElementById("ATTACHMENT") as HTMLInputElement;
        if (input) { input.value = ""; }
        message.error("File size is greater than 2MB");
        return;
      }
    }

    let base64Array: { id: any; name: string; data: string; sizeInBytes: number }[] = [];
    for (let i = 0; i < selectedfiles.length; i++) {
      let size = selectedfiles[i].size;
      //const sizeInMB = size / (1024 * 1024);
      let base64 = (await getBase64FromFilePromise(selectedfiles[i])) as string;
      base64 = String(base64).split("base64,")[1];
      base64Array.push({ id: 0, name: selectedfiles[i].name, data: base64, sizeInBytes: size });
    }

    setFiles((prev: any) => {
      if (prev) {
        return [...prev, ...base64Array];
      } else {
        return base64Array;
      }
    });
    setFormData((prev) => {
      return {
        ...prev,
        documents: files
      };
    })


    ////console.log("handleFileChange - files", files)

  };


  const formOnChange = (e: any, type: any, option: any) => {

    switch (type) {
      case "sectionComponent":
        setFormData((prev) => {
          return {
            ...prev,
            sectionComponent: e,
            sectionComponentText: option.label,
          };
        })
        break;
      case "documentType":
        setFormData((prev) => {
          return {
            ...prev,
            documentType: e,
            documentTypeText: option?.label,
          };
        })
        break;

      default:
        break;
    }
  }

  const validateForm = () => {

    let errorObj = {};
    let isError = false;

    setFormErrors({});

    if (
      formData?.sectionComponent === null ||
      formData?.sectionComponent === undefined
    ) {
      errorObj = {
        ...errorObj,
        ["sectionComponent"]: "Required section/Component",
      };
    } else {
      errorObj = {
        ...errorObj,
        ["sectionComponent"]: "",
      };
    }
    if (

      formData?.documentType === null ||
      formData?.documentType === undefined
    ) {
      errorObj = {
        ...errorObj,
        ["documentType"]: "Required documentType",
      };
    } else {
      errorObj = {
        ...errorObj,
        ["type"]: "",
      };
    }
    if (
      formData?.documents === "" ||
      formData?.documents === null ||
      formData?.documents === undefined
    ) {
      errorObj = {
        ...errorObj,
        ["documents"]: "Required document",
      };
    } else {
      errorObj = {
        ...errorObj,
        ["documents"]: "",
      };
    }

    const isEmptyData = Object.values(errorObj).every((s) => s === "");

    if (Object.keys(errorObj).length > 0 && !isEmptyData) {
      isError = true;
      setFormErrors((err) => ({
        ...err,
        ...errorObj,
      }));
    }

    return isError;
  };

  const handleAddFunction = async () => {
    showLoader();

    // if (validateForm()) {
    //   hideLoader();
    //   return;
    // }
    // const input = document.getElementById("ATTACHMENT") as HTMLInputElement;
    // if (input) input.value = "";
    ////console.log('amount after add button =>', amount)
    //setIsDisable(false);
    //console.log('inside add handele formdata=>', formData)
    await addSubmissionData();

    //reset();

    hideLoader();
  };

  const validateAdditionalField = () => {
    let isValid = true;

    cycleList?.forEach((cycle) => {
      // if (cycle.isCurrentCycle === true || cycle.isCurrentCycle === 1) {

        const lastDetail = cycle.cycleDetails?.reverse()?.find((details) => {
          return details.status === 'Not Submitted' && details.additionalFieldListV2.length > 0;
        });


        if (lastDetail) {
          const invalidField = lastDetail.additionalFieldListV2?.find((field) => {
            return field.fieldValue === "";
          });

          if (invalidField) {
            message.error('Please fill the details for all fields.');
            isValid = false;
          }
        }
     // }
    });

    return isValid;
  };

  const addSubmissionData = async () => {
    showLoader();

    let isAdditionalValid = validateAdditionalField();
    //console.log('isAdditionalValid==>', isAdditionalValid)
    if (!isAdditionalValid) {
      hideLoader();
      return;
    }

    //let isError = validateForm();
    //console.log('inside add after additional validationnn=>', formData)
    //  setFormData({})
    let isFormValid = await validateForm();
    //console.log('isFormValid==>', isFormValid, 'formdata=>', formData);
    if (isFormValid) {
      hideLoader();
      return;
    }
    // if (!isError) {

    //console.log('inside add after validationnn')
    const input = document.getElementById("ATTACHMENT") as HTMLInputElement;
    if (input) input.value = "";
    //setIsDisable(false);
    setIsAdded(true);
    addCycleCardDetails();
    setFormData({})
    //getAdditionalFeild(configurationId, false, null);
    let fileName = files[0]?.name;
    let data = files[0]?.data;
    let fileType = "";
    if (fileName?.toLowerCase().endsWith('.pdf')) {
      fileType = 'pdf';
    }
    else if (fileName?.toLowerCase().endsWith('.jpg') || fileName?.toLowerCase().endsWith('.jpeg') || fileName?.toLowerCase().endsWith('.png')) {
      fileType = 'image';
    }
    setFileType(fileType);
    setViewerKey(prev => prev + 1);
    setFileBase64(data);
    setStartDateMap({});
    setEndDateMap({});
    // getAdditionalFeild(null,configurationId, false, null);
    form.resetFields()
    setFiles([]);
    // }
    hideLoader();
  };

   const handleFocusedCurrent=(currentItem,idx)=>{
    setCurrentSelectedItem(currentItem)
    //console.log('currentitemclicked',currentItem)
     if(currentItem?.status == "Approved" || currentItem?.status == "Rejected" )
     {
      setIsDisable(true); 
      setIsApprovedOrRejectedVisible(false);
      setIsUndoButtonVisible(true);
     }else{
      setIsDisable(false);
      setIsApprovedOrRejectedVisible(true);
      setIsUndoButtonVisible(true);
      }
    //  if (currentItem?.status === "Draft" || currentItem?.status === "Not Submitted") {
    //     //setIsDisable(false); 
    //     setShowVerifierRemark(false);
    //   }else{
    //      //console.log('currentItem?.status',currentItem)
    //     if(currentItem?.status === "Approved" || currentItem?.status === "Rejected" || currentItem?.status === "Partially Accepted"){
    //         setShowVerifierRemark(true)
    //     }else{
    //       setShowVerifierRemark(false)
    //     }

      //setIsDisable(true);
    //}

    // let fileName = currentItem?.fileName;
    //   let data = currentItem?.fileBase64;
    //   let fileType = "";
    //   let filePath = ""
    //   //  setCurrentSrNo(item.srNo);
    //   //  currSrNo = item.srNo;
    //   //  ////console.log("currentSrNo:", currentSrNo)

    //   if (fileName?.toLowerCase().endsWith(".pdf")) {
    //     fileType = "pdf";
    //   } else if (
    //     fileName?.toLowerCase().endsWith(".jpg") ||
    //     fileName?.toLowerCase().endsWith(".jpeg") ||
    //     fileName?.toLowerCase().endsWith(".png")
    //   ) {
    //     fileType = "image";
    //   }
    //   setFileType(fileType);
    //   setFileBase64(data);

//handleFileClick(currentItem?.fileName,currentItem?.fileBase64,currentItem?.filePath);

    let currentOgemployeeSubmissionFinalDetailsId = ""
    let section = ""
    let updatedCycleList = cycleList.map((item)=>{

      return{
        ...item,
        cycleDetails:item.cycleDetails.map((item)=>{
          if(deepEqual(item,currentItem))
          {
            currentOgemployeeSubmissionFinalDetailsId = item?.employeeSubmissionFinalDetailsAdditionlFieldId
            section = item?.sectionName
            return{
              ...item,
              isAdditionalFieldFocused:true
            }
          }
          return {
            ...item,
            isAdditionalFieldFocused:false
          }
        })
      }
        
        
    })
    
    setCycleList(updatedCycleList)
    SetIsEditClicked(true);
    setSectionName(section);
    setCurrentFieldOgemployeeSubmissionFinalDetailsAdditionlFieldId(currentOgemployeeSubmissionFinalDetailsId);
    handleFileClick(currentItem?.fileName,currentItem?.fileBase64,currentItem?.filePath);
    handleViewDetails(currentItem,idx)
  }


  const getCycleCardDetails = async () => {
    showLoader();
    ////console.log('getCycleCardDetails cycles==>', cycleList)
    const currentCycle = cycleList.filter(
      x => x.isCurrentCycle === true || x.isCurrentCycle === 1
    );
    ////console.log("currentCycle==>", currentCycle)
    setInvestmentCycleId(currentCycle[0]?.id);

    // const validData = cycles.filter(x => x.sectionName);
    // //////console.log('hiiii')
    // //////console.log('validData==>',validData)

    // if (validData.length > 0) {
    //   arrayToSubmit.current = [];
    //   arrayToSubmit.current.push(...validData);
    //   setIsAdded(true);
    //   //////console.log('cueenet array', arrayToSubmit)
    // }

    var Id = cycleList[0]?.cycleDetails.length > 0 ? Math.max(...cycleList[0].cycleDetails.map((item) => item.newId)) : 0;
    setNewId(Id);

    // Group cycles by Id

    //   const groupedMap = new Map<string, any[]>();

    //   for (const item of cycleList.cycleMasterList) {
    //      ////console.log('Processing cycle item:', item);
    //     if (!groupedMap.has(item.Id)) {
    //       groupedMap.set(item.Id, []);
    //     }
    //     groupedMap.get(item.Id)!.push(item);
    //   }
    ////console.log('cycleList.cycleMasterList==>', cycleList.map((item: any) => item))


    // Create grouped collapsible items
    const items: CollapseProps["items"] = cycleList.map((item: any) => {
      ////console.log('current item=>', item)
      return {
        key: item.id,
        label: item.cycle,

        children: (
          <>
            {item.cycleDetails.map((innerItem: any, idx: any) => (
              (innerItem.sectionName &&
                <div className="accordCont" key={idx}
                  onClick={() => handleFocusedCurrent(innerItem,idx)}
                  style={{backgroundColor:innerItem.isAdditionalFieldFocused?"#c6d9f7":"white"}}
                >
                  <p>
                    {innerItem.sectionName}:<br /> {(innerItem?.status == "Approved") ? <span className="aprroved">{innerItem.status}</span> : (innerItem?.status == "Rejected") ? <span className="reject">{innerItem.status}</span> : <span className="pending">{innerItem.status}</span>} 
                    {/* <Dropdown overlay={getMenu(innerItem)} trigger={["click"]} placement="bottomRight">
                      <Button
                        className="popOption"
                        type="text"
                        onClick={(e: any) => {
                            e.preventDefault();
                            e.stopPropagation();
                          }
                        }
                      >
                        <BsThreeDotsVertical />
                      </Button>
                    </Dropdown> */}
                  </p>
                  <p>{innerItem.documentType}</p>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleEdit(innerItem, true,idx);
                      handleFileClick(innerItem.fileName, innerItem.fileBase64, innerItem.filePath);
                    }}
                  >
                    {innerItem.fileName}
                  </a>
                  <p className="mt-1">Submission Date : {innerItem.submittedDate}</p>
                </div>
              )

            ))}
          </>
        )

      };
    }
    );

    ////console.log("items===>", items)

    setCollapsibleItems(items);
    hideLoader();
    //getAdditionalFeild(currentCycle[0].configurationId, true, currentCycle[0]);
  };


  const addCycleCardDetails = async () => {

    const currentCycle = (cycleList as any[]).filter(
      x => x.isCurrentCycle === true || x.isCurrentCycle === 1);
    setInvestmentCycleId(currentCycle[0].id);

    ////console.log("current while adding cycle==>", currentCycle[0])


    // ////console.log('arrayToSubmit==> in add=>',arrayToSubmit)
    // const maxSrNo = Math.max(...currentCycle[0].cycleDetails.map(item => item.srNo));
    // const newSrNo = maxSrNo + 1;
    // setCurrentSrNo(newSrNo);
    // currSrNo = newSrNo;
    //////console.log("currentSrNo:", currentSrNo)
    const lastFile = files[files.length - 1];

    ////console.log('recent file =>', lastFile)

    const newItem = {
      Id: null,
      IsActive: null,
      isEdited: true,
      amount: Number(amount),
      componentId: componentId,
      configurationId: configurationId,
      documentType: formData?.documentTypeText,
      documentTypeId: Number(formData?.documentType.value) || 0,
      employeeFinalSubmissionId: null,
      employeeSubmissionId: null,
      fileBase64: lastFile?.data,
      fileName: lastFile?.name,
      files: lastFile ? [lastFile] : [],
      filePath: null,
      fileSizeInBytes: null,
      newId: null,
      remark: null,
      sectionId: sectionId,
      sectionName: formData?.sectionComponentText,
      status: 'Not Submitted',
      submittedDate: null,
      additionalFieldListV2: [],
      isAdditionalFieldFocused: true,
      investmentCycleId: cycleList[0].id || 0,
      financialYearId: currentFinancialYearId,
      UserId: userId,
      CategoryId: 1,// for investment
      FilePassword: verifiedPassword ? verifiedPassword : null
    };

    //currentCycle[0].cycleDetails.push(newItem);
    ////console.log('new item ==>', newItem)
    setSectionName(formData?.sectionComponentText);

    const updatedCycleList = cycleList.map((cycle) => {
     // if (cycle.isCurrentCycle === true || cycle.isCurrentCycle === 1) {
        const updatedCycleDetails = cycle.cycleDetails.map(detail => ({
          ...detail,
          isAdditionalFieldFocused: false,
        }));

        return {
          ...cycle,
          cycleDetails: [...updatedCycleDetails, newItem],
        };
      //}

     // return cycle;
    });

    //setCycleList(updatedCycleList);
    getAdditionalFeild(updatedCycleList, configurationId, false, null);

  }

  const handleEdit = (item: any, isFileClick: any,itemindex:any=0) => {
    //console.log('handle edit funcion ',item)
    ////console.log('item in edit ==>', item)
    ////console.log('cyclelist in edit =>', cycleList)
    if (item.status === 'Approved' || item.status === 'Rejected') {
      setIsDisable(true)
    }
      let currSystemName = item?.sectionName || "";
      let replicate = item?.additionalFieldListV2?.[0]?.isReplicable ? item?.additionalFieldListV2?.[0]?.isReplicable : false;
      setIsReplicable(replicate);
      let fileName = item.fileName;
      let data = item.fileBase64;
      let fileType = "";
      //  setCurrentSrNo(item.srNo);
      //  currSrNo = item.srNo;
      //  ////console.log("currentSrNo:", currentSrNo)

      if (fileName.toLowerCase().endsWith('.pdf')) {
        fileType = 'pdf';
      }
      else if (fileName.toLowerCase().endsWith('.jpg') || fileName.toLowerCase().endsWith('.jpeg') || fileName.toLowerCase().endsWith('.png')) {
        fileType = 'image';
      }
      setFileType(fileType);
      setViewerKey(prev => prev + 1);
      setFileBase64(data);
      // if(item.status === 'Draft'){
      let currentFinalAdditionalFieldIds = "";
      let updatedFieldValue = cycleList.map((cycle) => {
        // if (cycle.isCurrentCycle == true) {
          return {
            ...cycle,
            cycleDetails: cycle.cycleDetails.map((details,index) => {
              if (index == itemindex && details.sectionName == item.sectionName && details.employeeFinalSubmissionId == item.employeeFinalSubmissionId && details.employeeSubmissionId == item.employeeSubmissionId) {
                
                currentFinalAdditionalFieldIds = details?.employeeSubmissionFinalDetailsAdditionlFieldId
                return {
                  ...details,
                  isAdditionalFieldFocused: true,
                  additionalFieldListV2: item.additionalFieldListV2,
                  amount: Number(item.amount),
                  remark: item.remark,
                  verifierRemarks:item.verifierRemarks,

                }
              }
              return { ...details, isAdditionalFieldFocused: false, };
            })
          }
        //}
       // return cycle
      })
      //console.log('updatedFieldValue in edit==>', updatedFieldValue)
      setCycleList(updatedFieldValue);
      SetIsEditClicked(true);
      setCurrentFieldOgemployeeSubmissionFinalDetailsAdditionlFieldId(currentFinalAdditionalFieldIds)
      BindLetPropertyValuesOnEdit(item, currSystemName);
      BindInterestPaid(updatedFieldValue);

      // }

    // }
    // else {
    //   handleViewDetails(item)
    //   if (!isFileClick) {
    //     message.info("You can only edit when the status is 'Draft' or 'Not Submitted'.");
    //   }
    // }
  }

  const handleDeleteSubmission = async(item)=>{
      let updatedCycleList = cycleList.map((cycles)=>{

      return{
        ...cycles,
        cycleDetails:cycles.cycleDetails.filter((cycleitems)=>{
          if(!deepEqual(cycleitems,item))
          {
            return{
              ...cycleitems,
              //isAdditionalFieldFocused:true
            }
          }
        })
      }
        
        
    })

     let updatedCycleListWithDefaultFocus = updatedCycleList.map((cycles)=>{

      return{
        ...cycles,
        cycleDetails:cycles.cycleDetails.map((cycleitems,index)=>{
          if(index == 0)
          {
            return{
              ...cycleitems,
              isAdditionalFieldFocused:true
            }
          }
          return{
              ...cycleitems,
              isAdditionalFieldFocused:false
            }
        })
      }
        
        
    })

    setCycleList(updatedCycleListWithDefaultFocus)
  }

  // const handleDelete = async (item: any) => {
  
  //   if (item.status === 'Draft' || item.status === 'Not Submitted'  ) {
  //     const requestParams = {
  //       EmployeeSubmissionId: item.employeeSubmissionId,
  //       EmployeeFinalSubmissionId: item.employeeFinalSubmissionId,
  //       CreatedBy: userId,
  //     }
  //     const response = await API.post(DeleteSubmissionData, requestParams);

  //     if (response?.data.status === 0) {
  //       const id = response?.data?.id;
  //       await handleDeleteSubmission(item);
  //       message.success("Submission data deleted successfully.");

  //     } else if (response?.data.status === 1) {
  //       message.error("Failed to delete submission data.");
  //     }
  //   }
  //   else {
  //     handleViewDetails(item)
  //     message.info("You can only delete when the status is 'Draft' or 'Not Submitted'.");
  //   }
  // }

  const handleViewDetails = (item: any,idx:any) => {
   // setIsDisable(true)

    //  if (item?.status === "Draft" || item?.status === "Not Submitted") {
    //     setIsDisable(false); 
    //   }else{
    //   setIsDisable(true);
    // }
    ////console.log('view handle item=>',item)
    ////console.log('view handle cycle list=>',cycleList)
    let currSystemName = item?.sectionName || "";
    let replicate = item?.additionalFieldListV2?.[0]?.isReplicable ? item?.additionalFieldListV2?.[0].isReplicable : false;
    setIsReplicable(replicate);
    let fileName = item.fileName;
    let data = item.fileBase64;
    let fileType = "";
    //  setCurrentSrNo(item.srNo);
    //  currSrNo = item.srNo;
    //  ////console.log("currentSrNo:", currentSrNo)

    if (fileName?.toLowerCase().endsWith('.pdf')) {
      fileType = 'pdf';
    }
    else if (fileName?.toLowerCase().endsWith('.jpg') || fileName?.toLowerCase().endsWith('.jpeg') || fileName?.toLowerCase().endsWith('.png')) {
      fileType = 'image';
    }
    setFileType(fileType);
    setViewerKey(prev => prev + 1);
    setFileBase64(data);
    // if(item.status === 'Draft'){

    let updatedFieldValue = cycleList.map((cycle) => {
      // if (cycle.isCurrentCycle == true) {
        return {
          ...cycle,
          cycleDetails: cycle.cycleDetails.map((details,index) => {
            if (index == idx && details.sectionName == item.sectionName && details.employeeFinalSubmissionId == item.employeeFinalSubmissionId && details.employeeSubmissionId == item.employeeSubmissionId) {
              return {
                ...details,
                isAdditionalFieldFocused: true,
                additionalFieldListV2: item.additionalFieldListV2,
                amount: Number(item.amount),
                remark: item.remark,
                verifierRemarks:item.verifierRemarks,
                //   details.additionalFieldListV2.map((field)=>{
                //   ////console.log('field 2',field)
                //   if(field.displayName == item.displayName && field.id == item.id)  //&& field.id == item.id
                //   {
                //       return{
                //         ...field,
                //         fieldValue: type === 'numeric'? String(event) : String(event.target.value)
                //       }

                //   }
                //   return field
                // })

              }
            }
            return { ...details, isAdditionalFieldFocused: false };
          })
        }
      // }
      // return cycle
    })
    ////console.log('updatedFieldValue in edit==>', updatedFieldValue)
    setCycleList(updatedFieldValue);
    SetIsEditClicked(true);

    BindLetPropertyValuesOnEdit(item, currSystemName);

  }



  const handleFileClick = async (fileName: any, data: any, filePath: any) => {
    showLoader();

    try {

      var base64data = "";

      if (filePath) {
        let response = await API.post(viewFile, {
          FilePath: filePath,
        });

        if (response.data && response.data.data) {
          base64data = response.data.data;
        }

      }
      else {
        base64data = data;
      }

      //let fileName = fileName;
      let fileType = "";

      if (fileName?.toLowerCase().endsWith('.pdf')) {
        fileType = 'pdf';
      }
      else if (fileName?.toLowerCase().endsWith('.jpg') || fileName?.toLowerCase().endsWith('.jpeg') || fileName?.toLowerCase().endsWith('.png')) {
        fileType = 'image';
      }

      setFileType(fileType);
      setViewerKey(prev => prev + 1);
      setFileBase64(base64data);
      //setFilePath(filePath);

    }
    catch (error) {
      hideLoader();
      console.error("Error:", error);
      //console.error("Error:", error.response.data);
      message.error(`Failed to perform getInvestmentCycle`);
    } finally {
      hideLoader();
    }
  }

  const getAdditionalFeild = async (updatedCycleList: any, configId: number | null, prefillData: boolean = false, dataToUse: any = null) => {

    const requestParams = { ConfigurationId: configId || null, CategoryType: 'Investment' };

    try {
      const { data: { data } } = await API.post(GetAdditionalFields, requestParams);

      if (data) {
        ////console.log(' additional field data==>', data?.additionalFieldListV2)
        const additionalFieldList = data?.additionalFieldListV2;
        const defaultId = 1;
        const updatedadditionalFieldListList = additionalFieldList?.map((item, index) => ({
          ...item,
          id: item.id || defaultId,
        }));
        //let recentIndexofCurrentCycle = cycleList.filter((cycle)=> cycle.isCurrentCycle == true || cycle.isCurrentCycle == 1).cycleDetails.length
        //////console.log('recentINdex',recentIndexofCurrentCycle)
        let cycleListWithAdditionField = updatedCycleList.map((item) => {
          ////console.log('item', item)
         // if (item.isCurrentCycle == true || item.isCurrentCycle == 1) {
            ////console.log('item.', item)
            return {
              ...item,
              cycleDetails: item.cycleDetails.map((itemdetails) => {
                if (itemdetails.isAdditionalFieldFocused) {
                  return {
                    ...itemdetails,
                    additionalFieldListV2: updatedadditionalFieldListList
                  }
                }
                return {
                  ...itemdetails,
                  isAdditionalFieldFocused: false
                }
              })

            }
         // }
         // return item
        })
        ////console.log('cycle list in additionalfield =>', cycleList)
        //console.log('cyellisteithaddiotn==>', cycleListWithAdditionField)
        setCycleList(cycleListWithAdditionField)
        setIsReplicable(updatedadditionalFieldListList[0]?.isReplicable);
        form.setFieldsValue({
          amount: Number(amount),
        });
        BindInterestPaid(cycleListWithAdditionField);

      } else {
        message.error("Failed to fetch additional fields.");
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("Error loading additional fields.");
    }
  };

  // const submitSubmissionData = async (isSubmit: boolean) => {
  //   try {
  //     //if (isSubmit) {
  //     const allFields = form.getFieldsValue();
  //     const fieldNames = Object.keys(allFields);
  //     //console.log('fieldNames==>', fieldNames)
  //     const fieldsToValidate = fieldNames.filter(
  //       name => name !== 'sectionComponent' && name !== 'DocumentType'
  //     );
  //     //console.log('fieldsToValidate==>', fieldsToValidate)
  //     const values = await form.validateFields(fieldsToValidate);

  //     ////console.log('fieldsToValidate==>', fieldsToValidate)
  //     ////console.log("Form is valid===>", values);
  //     // }
  //     ////console.log('in submit fuc cyc list=>', cycleList)

  //     if (cycleList.length > 0) {
  //       const currentObj = cycleList.find((ele: any) => ele.isCurrentCycle === true);
  //       const requestParams = { ...currentObj };
  //       if (isSubmit) {
  //         requestParams.isSubmit = isSubmit;
  //       }

  //       requestParams.cycleDetails = requestParams?.cycleDetails
  //         ?.filter((item: any) => item.status === "Draft" || item.status === "Not Submitted")
  //         .map((item: any) => ({
  //           ...item,
  //           amount: String(item.amount),  // Ensure amount is a string
  //         }));

  //       //console.log('final request params ===>', requestParams)
  //       const response = await API.post(SaveSubmissionData, requestParams);

  //       if (response?.data.status === 0) {
  //         const id = response?.data?.id;
  //         if (isSubmit) {
  //           form.resetFields();
  //           navigate("/form12bb", { replace: true });

  //         }
  //         else {
  //           form.resetFields();
  //           setShowForm(false);
  //           //setShowAdditionalField(false);
  //           const input = document.getElementById("ATTACHMENT") as HTMLInputElement;
  //           if (input) input.value = "";
  //           await GetSectionComponent();
  //           await getCycleCardDetails();
  //          // setIsDisable(false)
  //           message.success("Submission data added successfully.");

  //         }

  //       } else if (response?.data.status === 1) {
  //         message.error("Failed to add submission data.");
  //       }
  //     }
  //     else {
  //       message.error("No data to save.");
  //     }


  //   } catch (error) {
  //     // 👇 This handles Axios errors
  //     console.error("Axios error:", error);
  //     message.error("An error occurred while submitting data. Please try again.");
  //   }
  // }

  const expandIcon = (panelProps: any) => {
  //  //console.log('inside icon  ')
    const isActive = activeKeys.includes(panelProps.key);
    return isActive ? <MinusOutlined /> : <PlusOutlined />;
  };

  const handleCollapseChange = (keys: string | string[]) => {
   // //console.log('inside handle change ')
    setActiveKeys(Array.isArray(keys) ? keys : [keys]);
    ////console.log("Collapsible icon" + Array.isArray(keys) ? keys : [keys]);
  };

  const handlePasswordCheck = (e: any): Promise<boolean> => {
    const file = e.target.files[0];
    if (!file) return Promise.resolve(false);

    setFile(file);

    return new Promise((resolve) => {
      const result = checkIfPdfPasswordProtected(file);
      result?.then(() => {
        resolve(true);
      }).catch(() => {
        resolve(false);
      });

      (window as any).__pdfPasswordResolver = resolve;
    });
  };

  //working
  const checkIfPdfPasswordProtected = async (file: File) => {
    const fileReader = new FileReader();

    fileReader.onload = async (e) => {
      const uint8Array = new Uint8Array(e.target?.result as ArrayBuffer);

      try {

        await getDocument({ data: uint8Array, password }).promise;


        setIsPasswordProtected(false);
        setShowModal(false);
      } catch (error: any) {
        if (error?.name === 'PasswordException') {
          ////console.log('PDF is password protected');
          setFile(file);
          setIsPasswordProtected(true);
          setShowModal(true);
          setVerifiedPassword(password);
          ////console.log('password==>', password)
        } else {
          console.error('Error loading PDF:', error);
          message.error('Failed to load PDF');
        }
      }
    };

    fileReader.readAsArrayBuffer(file);
  };


  const handlePasswordSubmit = async () => {
    if (!password.trim()) {
      setErrorMessage('Please enter a password');
      return;
    }

    try {
      const fileReader = new FileReader();

      fileReader.onload = async (e) => {
        const uint8Array = new Uint8Array(e.target?.result as ArrayBuffer);

        const loadingTask = getDocument({ data: uint8Array, password });

        loadingTask.promise
          .then((pdf: any) => {
            ////console.log('PDF loaded successfully with password');
            setShowModal(false);
            setErrorMessage('');
            message.success('PDF loaded!');
            setVerifiedPassword(password);
            ////console.log('pdf===>', pdf)
            ////console.log('password===>', password)

          })
          .catch((err: any) => {
            console.error('Incorrect password or error:', err);
            if (err?.name === 'PasswordException') {
              setErrorMessage('Incorrect password!');
            } else {
              message.error('Failed to load PDF.');
            }
          });
      };

      fileReader.readAsArrayBuffer(file);
    } catch (error) {
      console.error('Error in password submit:', error);
      message.error('Unexpected error');
    }
  };

  const handleModalClose = () => {
    const input = document.getElementById("ATTACHMENT") as HTMLInputElement;
    if (input) input.value = "";
    setSelectedFiles(null);
    setFiles([]);
    setShowModal(false);
    setErrorMessage('');
    setPassword('');
  };

  const handleReplicate = () => {
    const updatedCycleList = cycleList.map((cycle) => {
     // if (cycle.isCurrentCycle) {
        return {
          ...cycle,
          cycleDetails: cycle.cycleDetails.map((details) => {
            if (details.isAdditionalFieldFocused) {

            const idArray = details?.employeeSubmissionFinalDetailsAdditionlFieldId
            ? details.employeeSubmissionFinalDetailsAdditionlFieldId
                .split(',')
                .map(id => Number(id.trim()))
            : [];

          const maxAdditionalFieldId = idArray.length > 0 ? Math.max(...idArray) : 0;
          const newId = maxAdditionalFieldId + 1;
          const updatedIdString = [...idArray, newId].join(',');

              const { additionalFieldListV2 } = details;

              // Find the max ID (last group)
              const maxId = Math.max(...additionalFieldListV2.map(item => item.id));

              // Filter only the last group based on maxId
              const lastGroup = additionalFieldListV2.filter(item => item.id === maxId);

              // Clone the group with new id
              const newGroup = lastGroup.map(item => ({
                ...item,
                id: maxAdditionalFieldId + 1,
                fieldValue: '',
                employeeSubmissionFinalDetailsAdditionlFieldId: updatedIdString,
              }));

              return {
                ...details,
                employeeSubmissionFinalDetailsAdditionlFieldId: updatedIdString,
                additionalFieldListV2: [...additionalFieldListV2, ...newGroup],
              };
            }

            return details;
          }),
        };
      // }

      // return cycle;
    });

  
     const formValues = form.getFieldsValue();

       console.log('filteredValues',formValues)

    // const filteredValues = Object.fromEntries(
    //   Object.entries(formValues).filter(
    //     ([key]) => !key.includes(`-${formValues.maxId}-`) // optional based on your naming
    //   )
    // );
    // form.setFieldsValue(filteredValues);
    
    // console.log('formvalue s',filteredValues)
    console.log('updatesccycle when adding',updatedCycleList)
    setCycleList(updatedCycleList);
  };



  // const handleAdditionalChange = (event : any, type : any, item : any, subdetails :any)=>{
  //  // if( type === "numeric"){
  //     ////console.log('cycle==>',cycleList)
  //     ////console.log('event for numeric==>',event);
  //     ////console.log('type for numeric==>',type);
  //     ////console.log('curren item on change for numeric==>',item);
  //     ////console.log('subdetails for =>',subdetails);
  //     let updatedFieldValue = cycleList.map((cycle)=>{
  //       if(cycle.isCurrentCycle == true){
  //           return{
  //             ...cycle,
  //             cycleDetails: cycle.cycleDetails.map((details)=>{
  //                 if(details.isAdditionalFieldFocused == true)
  //                 {
  //                     return{
  //                         ...details,
  //                         additionalFieldListV2:details.additionalFieldListV2.map((field)=>{
  //                           ////console.log('field 2',field)
  //                           if(field.displayName == item.displayName && field.id == item.id)  //&& field.id == item.id
  //                           {
  //                               // return{
  //                               //   ...field,
  //                               //   fieldValue: type === 'numeric'? String(event) : String(event.target.value)
  //                               // }
  //                               let newValue = "";

  //                               switch (type) {
  //                                 case "numeric":
  //                                   newValue = String(event);
  //                                   break;

  //                                 case "textInput":
  //                                   newValue = event?.target?.value || "";
  //                                   break;

  //                                 case "radioButton":
  //                                   newValue = event?.target?.value || "";
  //                                   break;

  //                                 case "choices":
  //                                   newValue = Array.isArray(event) ? event.join(",") : "";
  //                                   break;

  //                                 case "date":
  //                                   newValue = event ? event.format("YYYY-MM-DD") : "";
  //                                   break;

  //                                 case "dropdown":
  //                                   newValue = event;
  //                                   break;

  //                                 default:
  //                                   newValue = "";
  //                               }

  //                               return {
  //                                 ...field,
  //                                 fieldValue: newValue
  //                               };

  //                           }
  //                           return field
  //                         })
  //                     }
  //                 } 
  //                 return details;
  //             })
  //           }
  //       }
  //       return cycle
  //     })

  //     setCycleList(updatedFieldValue)
  //   //}
  //   }
  const resetContributionValidations =(updatesCycleList)=>{
    let selffieldName = ""
    let othersfieldName = ""

    updatesCycleList?.forEach((updatesCycle)=>{
       // if(updatesCycle?.isCurrentCycle){
          //console.log('updatesCycle is ',updatesCycle)
            updatesCycle?.cycleDetails?.forEach((details)=>{
                if(details?.isAdditionalFieldFocused){
                  //console.log('detials,',details)
                  details?.additionalFieldListV2?.forEach((detail,index)=>{
                      if(detail?.displayName?.toLowerCase() == "self-contribution percentage")
                      {
                          selffieldName = `${detail?.fieldName}-${detail?.id}-${index}`
                      }
                      if(detail?.displayName?.toLowerCase() == "other's-contribution percentage")
                      {
                          othersfieldName = `${detail?.fieldName}-${detail?.id}-${index}`
                      }
                  })
                }
            })
       // }
    })
    form.validateFields([selffieldName,othersfieldName]);
  }

  const handleAdditionalChange = (event: any, type: string, item: any, subDetails: any) => {
    let valueToUpdate: string = "";
    let currSectionName: string = "";
   

    if (type === "numeric") {
      valueToUpdate = String(event);
    } else if (type === "textInput" || type === "radioButton") {
      valueToUpdate = event?.target?.value ?? "";
    } else if (type === "choices") {
      valueToUpdate = Array.isArray(event) ? event.join(",") : "";
    } else if (type === "date") {
      valueToUpdate = event ? event.format("YYYY-MM-DD") : "";
      // valueToUpdate = event ? moment(event).format("YYYY-MM-DD"): "";
    } else if (type === "dropdown") {
      valueToUpdate = event ?? "";
    }
    //console.log('value to update =>', valueToUpdate)

    const updatedCycleList = cycleList.map((cycle) => {
      // if (cycle.isCurrentCycle) {
        return {
          ...cycle,
          cycleDetails: cycle.cycleDetails.map((details) => {
            if (details.isAdditionalFieldFocused) {
              return {
                ...details,
                additionalFieldListV2: details.additionalFieldListV2.map((field) => {
                  if (field.displayName === item.displayName && field.id === item.id) {
                    currSectionName = details.sectionName;
                    return {
                      ...field,
                      fieldValue: valueToUpdate,
                    };
                  }
                  return field;
                }),
              };
            }
            return details;
          }),
        };
      // }
      // return cycle;
    });

    setChangedFieldName(item.displayName);
    setChangedItemId(item.id);
    resetContributionValidations(updatedCycleList);
    setCycleList(updatedCycleList);
    BindLetPropertyValuesOnChange(updatedCycleList, currSectionName);
   // BindJointloanPropertyValuesOnChange(updatedCycleList, currSectionName)
  };



  useEffect(() => {
    //console.log("changed field name : ", changedFieldName);
    if (changedFieldName.toLocaleLowerCase().includes("is it a let property?") ||
      changedFieldName.toLocaleLowerCase().includes("income from hp/notional rent") ||
      changedFieldName.toLocaleLowerCase().includes("municipal taxes paid") ||
      changedFieldName.toLocaleLowerCase().includes("interest paid on property") //||
      // changedFieldName.toLocaleLowerCase().includes("(-)30% standard deduction") ||
      // changedFieldName.toLocaleLowerCase().includes("income/loss from hp")
    ) {

      var updatedItem = cycleList
        //.find(cycle => cycle.isCurrentCycle)
        ?.cycleDetails
        ?.find(details => details.isAdditionalFieldFocused);
      //calculateOnChange(changedSectionId, changedEmpDeclarationDetailsId, changedCount);
      calculateOnChange(updatedItem, changedItemId);
    }
    else if (changedFieldName.toLocaleLowerCase().includes("is it a joint loan?") ||
      changedFieldName.toLocaleLowerCase().includes("joint holder's name (comma separated)") ||
      changedFieldName.toLocaleLowerCase().includes("relationship") ||
      changedFieldName.toLocaleLowerCase().includes("self-contribution percentage") ||
      changedFieldName.toLocaleLowerCase().includes("other's-contribution percentage") ||
       changedFieldName.toLocaleLowerCase().includes("eligible amount")
       //||
      // changedFieldName.toLocaleLowerCase().includes("(-)30% standard deduction") ||
      // changedFieldName.toLocaleLowerCase().includes("income/loss from hp")
    ) {

      var updatedItem = cycleList
        //.find(cycle => cycle.isCurrentCycle)
        ?.cycleDetails
        ?.find(details => details.isAdditionalFieldFocused);
      //calculateOnChange(changedSectionId, changedEmpDeclarationDetailsId, changedCount);
      calculateOnChange(updatedItem, changedItemId);
    }
  }, [changedFieldName])

  const handleOnchange = (event: any, fieldName: any) => {
    // ////console.log('event for onchange',event)
    // ////console.log('fieldName for onchange',fieldName)

    if (fieldName === "amount") {

      // setAmount(String(event));
      let updatedFieldValue = cycleList.map((cycle) => {
        //if (cycle.isCurrentCycle == true) {
          return {
            ...cycle,
            cycleDetails: cycle.cycleDetails.map((details) => {
              if (details.isAdditionalFieldFocused == true) {
                return {
                  ...details,
                  amount: String(event)
                }
              }
              return details;
            })
          }
        // }
        // return cycle
      })

      ////console.log('updatedFieldValue on handle change amout', updatedFieldValue)

      setCycleList(updatedFieldValue);
      BindInterestPaid(updatedFieldValue);
    }
    else if (fieldName === "remark") {
      // ////console.log('remarkevent=>',event.target.value)
      setRemark(event.target.value);
      let updatedFieldValue = cycleList.map((cycle) => {
        //if (cycle.isCurrentCycle == true) {
          return {
            ...cycle,
            cycleDetails: cycle.cycleDetails.map((details) => {
              if (details.isAdditionalFieldFocused == true) {
                return {
                  ...details,
                  remark: String(event.target.value)

                }
              }
              return details;
            })
          }
        // }
        // return cycle
      })

      // ////console.log('updatedFieldValue on handle change remark',updatedFieldValue)

      setCycleList(updatedFieldValue)
    }
     else if (fieldName === "verifierRemark") {
      // ////console.log('remarkevent=>',event.target.value)
      setVerifierRemark(event.target.value);
      let updatedFieldValue = cycleList.map((cycle) => {
        // if (cycle.isCurrentCycle == true) {
          return {
            ...cycle,
            cycleDetails: cycle.cycleDetails.map((details) => {
              if (details.isAdditionalFieldFocused == true) {
                return {
                  ...details,
                  verifierRemarks: String(event.target.value)

                }
              }
              return details;
            })
          }
        // }
        // return cycle
      })

      // ////console.log('updatedFieldValue on handle change remark',updatedFieldValue)

      setCycleList(updatedFieldValue)
    }

  }

  const replicatePreviousFields = (currentId: number, event: boolean) => {
    const initialValues: Record<string, any> = {};

    const updatedValues = cycleList.map((cycle) => {
      //if (!cycle.isCurrentCycle) return cycle;

      return {
        ...cycle,
        cycleDetails: cycle.cycleDetails.map((details) => {
          if (!details.isAdditionalFieldFocused) return details;

          // Group by ID
          const groupedById: Record<number, any[]> = {};
          details.additionalFieldListV2.forEach((item) => {
            if (!groupedById[item.id]) groupedById[item.id] = [];
            groupedById[item.id].push(item);
          });

          const allIds = Object.keys(groupedById).map(Number).sort((a, b) => a - b);
          const currentIndex = allIds.indexOf(currentId);
          const prevId = allIds[currentIndex - 1];
          const prevItems = groupedById[prevId] || [];
          const currItems = groupedById[currentId] || [];

          const targetFields = [
            "Name of the landlord",
            "PAN of the landlord",
            "Address of property",
            "City"
          ];

          // Update field values in state
          const newFieldList = details.additionalFieldListV2.map((item) => {
            if (item.id !== currentId) return item;

            const cleanedDisplayName = item.displayName.trim();
            if (!targetFields.includes(cleanedDisplayName)) return item;

            const matchingPrevItem = prevItems?.find(
              (pre) => pre.displayName.trim() === cleanedDisplayName
            );

            return {
              ...item,
              fieldValue: event ? (matchingPrevItem?.fieldValue ?? "") : "",
            };
          });

          // Update form values
          targetFields.forEach((field) => {
            const currItem = currItems?.find(c => c.displayName.trim() === field);
            if (!currItem) return;

            const key = `${currItem.fieldName}-${currItem.id}-${details.additionalFieldListV2.indexOf(currItem)}`;
            const matchingPrevItem = prevItems?.find(p => p.displayName.trim() === field);

            if (event) {
              if (matchingPrevItem) {
                const responseType = matchingPrevItem.responseType?.toLowerCase();
                let value: any = "";

                if (responseType === "choices") {
                  value = matchingPrevItem.fieldValue ? matchingPrevItem.fieldValue.split(",") : [];
                } else if (responseType === "numeric") {
                  value = Number(matchingPrevItem.fieldValue);
                } else if (responseType === "date") {
                  const parsed = dayjs(matchingPrevItem.fieldValue);
                  value = parsed.isValid() ? parsed : null;
                } else {
                  value = matchingPrevItem.fieldValue ?? "";
                }

                initialValues[key] = value;
              }
            } else {
              const responseType = currItem.responseType?.toLowerCase();
              initialValues[key] =
                responseType === "choices" ? [] :
                  responseType === "date" ? null :
                    "";
            }
          });

          return {
            ...details,
            additionalFieldListV2: newFieldList,
          };
        }),
      };
    });

    console.log("Values to set on replicate/clear toggle =>", initialValues);
    console.log("updatedValues in same as above",updatedValues)
    form.setFieldsValue(initialValues);
    setCycleList(updatedValues);
  };


  const handleRemove = (removeId) => {

    const allKeys = form.getFieldsValue();
    const keysToReset = Object.keys(allKeys).filter(key => key.includes(`-${removeId}-`));
    form.resetFields(keysToReset);

    setCurrentRemovedId(removeId)
    // Step 1: Remove from cycleList
    console.log('before removing data',cycleList)
    console.log('before removing form',form.getFieldsValue());

 
   

    const removedCycleList = cycleList.map((cycle) => {
      //if (cycle.isCurrentCycle) {
        return {
          ...cycle,
          cycleDetails: cycle.cycleDetails.map((cycledetails) => {
            if (cycledetails.isAdditionalFieldFocused) {

              const originalIds = employeeSubmissionOgFinalDetailsAdditionlFieldId
                ?.split(",")
                .map((id) => Number(id.trim()));

              const isInOriginal = originalIds?.includes(removeId);
               let updatedIdString = cycledetails.employeeSubmissionFinalDetailsAdditionlFieldId;
                if (!isInOriginal && updatedIdString) {
                  const currentIds = updatedIdString
                    .split(",")
                    .map((id) => Number(id.trim()))
                    .filter((id) => id !== removeId);

                  updatedIdString = currentIds.join(",");
                }

              return {
                ...cycledetails,
                additionalFieldListV2: cycledetails.additionalFieldListV2.filter(
                  (addfield) => addfield.id !== removeId
                ),
                employeeSubmissionFinalDetailsAdditionlFieldId: updatedIdString,
              };
            }
            return cycledetails;
          }),
        };
      // }
      // return cycle;
    });

    let formvalues = form.getFieldsValue();
    const filteredFormValues = Object.fromEntries(
      Object.entries(formvalues).filter(
        ([key,_]) => !key.includes(`-${removeId}-`)
      )
    )
    console.log('After removing data',removedCycleList)
    console.log('After removing form',filteredFormValues);
    
    form.setFieldsValue(filteredFormValues); //update form 
    setCycleList(removedCycleList); // Update state
    //setIsRemovedClicked(true)
  };

  const BindLetPropertyValuesOnEdit = (item: any, sectionName: any) => {

    setLetPropertyValues([]);
    setJointPropertyValues([]);

    var radioButtonValues: Array<any> = [];
    var radioJointLoanButtonValues: Array<any> = [];

    var currSectionName = sectionName ? sectionName : item?.sectionName;

    if (currSectionName?.toLocaleLowerCase() == "housing loan interest" || currSectionName?.toLocaleLowerCase() == "let out")
    //item?.sectionSystemName?.toLocaleLowerCase() == "hp_sectionmaster") 
    {
      item?.additionalFieldListV2?.forEach((aitem: any, index: any) => {
        if (aitem?.displayName?.toLocaleLowerCase().includes("is it a let property?")) {
          if (aitem?.fieldValue?.toLocaleLowerCase() == "yes") {
            radioButtonValues.push({
              //count: aitem?.count,
              id: aitem?.id,
              index: index,
              fieldColumnName: aitem?.fieldName,
              fieldName: aitem?.displayName,
              value: aitem?.fieldValue,
              renderNumeric: true,
            });
          }
          else {
            radioButtonValues.push({
              //count: aitem?.count,
              id: aitem?.id,
              index: index,
              fieldColumnName: aitem?.fieldName,
              fieldName: aitem?.displayName,
              value: aitem?.fieldValue,
              renderNumeric: false,
            });
          }
        }
          else if (aitem?.displayName?.toLocaleLowerCase().includes("is it a joint loan?")) {
                if (aitem?.fieldValue?.toLocaleLowerCase() == "yes") {
                  radioJointLoanButtonValues.push({
                    //count: aitem?.count,
                    id: aitem?.id,
                    index: index,
                    fieldColumnName: aitem?.fieldName,
                    fieldName: aitem?.displayName,
                    value: aitem?.fieldValue,
                    renderNumeric: true,
                  });
                }
                else {
                  radioJointLoanButtonValues.push({
                    //count: aitem?.count,
                    id: aitem?.id,
                    index: index,
                    fieldColumnName: aitem?.fieldName,
                    fieldName: aitem?.displayName,
                    value: aitem?.fieldValue,
                    renderNumeric: false,
                  });
                }
              }  

      });
    }
    ////console.log('radioButtonValues---',radioButtonValues)
    ////console.log('radioJointLoanButtonValues---',radioJointLoanButtonValues)
    setLetPropertyValues(radioButtonValues);
    setJointPropertyValues(radioJointLoanButtonValues);
  }

  const BindLetPropertyValuesOnChange = (currCycleList: any, sectionName: any) => {

    var radioButtonValues: Array<any> = [];
    var radioJointLoanButtonValues: Array<any> = [];

    if (currCycleList.length > 0) {
      currCycleList.forEach((item: any, index: any) => {
        item?.cycleDetails?.forEach((citem: any, index: any) => {
          if (citem.isAdditionalFieldFocused) {
            citem?.additionalFieldListV2?.forEach((aitem: any, index: any) => {
              if (aitem?.displayName?.toLocaleLowerCase().includes("is it a let property?")) {
                if (aitem?.fieldValue?.toLocaleLowerCase() == "yes") {
                  radioButtonValues.push({
                    //count: aitem?.count,
                    id: aitem?.id,
                    index: index,
                    fieldColumnName: aitem?.fieldName,
                    fieldName: aitem?.displayName,
                    value: aitem?.fieldValue,
                    renderNumeric: true,
                  });
                }
                else {
                  radioButtonValues.push({
                    //count: aitem?.count,
                    id: aitem?.id,
                    index: index,
                    fieldColumnName: aitem?.fieldName,
                    fieldName: aitem?.displayName,
                    value: aitem?.fieldValue,
                    renderNumeric: false,
                  });
                }
              } 
              else if (aitem?.displayName?.toLocaleLowerCase().includes("is it a joint loan?")) {
                if (aitem?.fieldValue?.toLocaleLowerCase() == "yes") {
                  radioJointLoanButtonValues.push({
                    //count: aitem?.count,
                    id: aitem?.id,
                    index: index,
                    fieldColumnName: aitem?.fieldName,
                    fieldName: aitem?.displayName,
                    value: aitem?.fieldValue,
                    renderNumeric: true,
                  });
                }
                else {
                  radioJointLoanButtonValues.push({
                    //count: aitem?.count,
                    id: aitem?.id,
                    index: index,
                    fieldColumnName: aitem?.fieldName,
                    fieldName: aitem?.displayName,
                    value: aitem?.fieldValue,
                    renderNumeric: false,
                  });
                }
              }  

            });
          }
        });
      });
    }

    setLetPropertyValues(radioButtonValues);
    setJointPropertyValues(radioJointLoanButtonValues);
  }

  // useEffect(() => {
  // }, [letPropertyValues,JointPropertyValues])

  const renderNumericFields = (item: any, sectionName: any, sectionSystemName: any, index: any) => {

    if (sectionName?.toLocaleLowerCase() == "housing loan interest" || sectionName?.toLocaleLowerCase() == "let out")
    //&& sectionSystemName?.toLocaleLowerCase() == "hp_sectionmaster") 
    {
      var fieldName = item?.displayName;
      if (fieldName.toLocaleLowerCase().includes("income from hp/notional rent") ||
        fieldName.toLocaleLowerCase().includes("municipal taxes paid") ||
        fieldName.toLocaleLowerCase().includes("(-)30% standard deduction")
      ) {
        var renderNumericValue = letPropertyValues?.find(x => x.id === item.id
          && index === index)?.renderNumeric;
          
        return renderNumericValue;
      }
      else if (fieldName.toLocaleLowerCase().includes("joint holder's name (comma separated)") ||
        fieldName.toLocaleLowerCase().includes("relationship") ||
        fieldName.toLocaleLowerCase().includes("self-contribution percentage") || 
        fieldName.toLocaleLowerCase().includes("other's-contribution percentage") ||
        fieldName.toLocaleLowerCase().includes("eligible amount")
      ) {
        var renderNumericValue = JointPropertyValues?.find(x => x.id === item.id
          && index === index)?.renderNumeric;
          

        return renderNumericValue;
      }
      else {
        return true;
      }
    }
    else {
      return true;
    }
  }

  const calculateOnChange = (updateditem: any, updatedId: any
    // sectionId: any,
    // employeeDeclarationDetailsId: any,
    // count: any
  ) => {

    var incomeFromHpNotionalRent = 0;
    var municipalTaxesPaid = 0;
    var interestPaidOnProperty = 0;
    var standardDeduction = 0;
    var incomeLossFromHp = 0;
    var sectionName = "";
    var contributionpercentage= 0
    var eligibleAmount= 0

    var incomeFromHpNotionalRentFieldColumnName = "";
    var municipalTaxesPaidFieldColumnName = "";

    var interestPaidOnPropertyFieldColumnName = "";
    var standardDeductionFieldColumnName = "";
    var incomeLossFromHpFieldColumnName = "";
    
    var contributionpercentageFieldColumnName = ""
    var eligibleAmountFieldColumnName = ""

    var incomeFromHpNotionalRentFieldName = "";
    var municipalTaxesPaidFieldName = "";
    var interestPaidOnPropertyFieldName = "";
    var standardDeductionFieldName = "";  //"(-)30% Standard deduction";
    var incomeLossFromHpFieldName = "";   //"Income/Loss from HP";

    var contributionpercentageFieldName = "";
    var eligibleAmountFieldName = "";

    //if (sectionName == "housingloaninterest_sectionmaster") 
    {
      var incomeFromHpNotionalRentUpdObj = updateditem?.additionalFieldListV2?.find
        (item => item.id === updatedId &&
          item.displayName.toLocaleLowerCase().includes("income from hp/notional rent"));

      incomeFromHpNotionalRent = incomeFromHpNotionalRentUpdObj != null ? (Number(incomeFromHpNotionalRentUpdObj.fieldValue) || 0) : incomeFromHpNotionalRent;
      incomeFromHpNotionalRentFieldColumnName = incomeFromHpNotionalRentUpdObj != null ? incomeFromHpNotionalRentUpdObj.fieldName : "";
      incomeFromHpNotionalRentFieldName = incomeFromHpNotionalRentUpdObj != null ? incomeFromHpNotionalRentUpdObj.displayName : "";

      var municipalTaxesPaidUpdObj = updateditem?.additionalFieldListV2?.find
        (item => item.id === updatedId &&
          item.displayName.toLocaleLowerCase().includes("municipal taxes paid"));

      municipalTaxesPaid = municipalTaxesPaidUpdObj != null ? (Number(municipalTaxesPaidUpdObj.fieldValue) || 0) : municipalTaxesPaid;
      municipalTaxesPaidFieldColumnName = municipalTaxesPaidUpdObj != null ? municipalTaxesPaidUpdObj.fieldName : "";
      municipalTaxesPaidFieldName = municipalTaxesPaidUpdObj != null ? municipalTaxesPaidUpdObj.displayName : "";

      var interestPaidOnPropertyUpdObj = updateditem?.additionalFieldListV2?.find
        (item => item.id === updatedId &&
          item.displayName.toLocaleLowerCase().includes("interest paid on property"));

      interestPaidOnProperty = interestPaidOnPropertyUpdObj != null ? (Number(interestPaidOnPropertyUpdObj.fieldValue) || 0) : interestPaidOnProperty;
      interestPaidOnPropertyFieldColumnName = interestPaidOnPropertyUpdObj != null ? interestPaidOnPropertyUpdObj.fieldName : "";
      interestPaidOnPropertyFieldName = interestPaidOnPropertyUpdObj != null ? interestPaidOnPropertyUpdObj.displayName : "";

      var standardDeductionUpdObj = updateditem?.additionalFieldListV2?.find
        (item => item.id === updatedId &&
          item.displayName.toLocaleLowerCase().includes("(-)30% standard deduction"));

      standardDeduction = standardDeductionUpdObj != null ? (Number(standardDeductionUpdObj.fieldValue) || 0) : standardDeduction;
      standardDeductionFieldColumnName = standardDeductionUpdObj != null ? standardDeductionUpdObj.fieldName : "";
      standardDeductionFieldName = standardDeductionUpdObj != null ? standardDeductionUpdObj.displayName : "";

      var incomeLossFromHpUpdObj = updateditem?.additionalFieldListV2?.find
        (item => item.id === updatedId &&
          item.displayName.toLocaleLowerCase().includes("income/loss from hp"));

      incomeLossFromHp = incomeLossFromHpUpdObj != null ? (Number(incomeLossFromHpUpdObj.fieldValue) || 0) : incomeLossFromHp;
      incomeLossFromHpFieldColumnName = incomeLossFromHpUpdObj != null ? incomeLossFromHpUpdObj.fieldName : "";
      incomeLossFromHpFieldName = incomeLossFromHpUpdObj != null ? incomeLossFromHpUpdObj.displayName : "";

      //

       var contributionSharedObj = updateditem?.additionalFieldListV2?.find
        (item => item.id === updatedId &&
          item.displayName.toLocaleLowerCase().includes("self-contribution percentage"));

      contributionpercentage = contributionSharedObj != null ? (Number(contributionSharedObj.fieldValue) || 0) : contributionpercentage;
      contributionpercentageFieldColumnName = contributionSharedObj != null ? contributionSharedObj.fieldName : "";
      contributionpercentageFieldName = contributionSharedObj != null ? contributionSharedObj.displayName : "";

      

      var eligibleAmountfieldObj  = updateditem?.additionalFieldListV2?.find
        (item => item.id === updatedId &&
          item.displayName.toLocaleLowerCase().includes("eligible amount"));
      eligibleAmount = eligibleAmountfieldObj != null ? (Number(eligibleAmountfieldObj.fieldValue) || 0) : eligibleAmount;
      eligibleAmountFieldColumnName = eligibleAmountfieldObj != null ? eligibleAmountfieldObj.fieldName : "";
      eligibleAmountFieldName = eligibleAmountfieldObj != null ? eligibleAmountfieldObj.displayName : "";




      var letProperty = updateditem?.additionalFieldListV2?.find
        (item => item.id === updatedId &&
          item.displayName.toLocaleLowerCase().includes("is it a let property?"));

      var letPropertyValue = letProperty != null ? letProperty.fieldValue : "";


      var jointProperty = updateditem?.additionalFieldListV2?.find
        (item => item.id === updatedId &&
          item.displayName.toLocaleLowerCase().includes("is it a joint loan?"));

      var jointPropertyValue = jointProperty != null ? jointProperty.fieldValue : "";



      if (letPropertyValue.toLocaleLowerCase() == "no") {
        incomeFromHpNotionalRent = 0;
        municipalTaxesPaid = 0;
        standardDeduction = 0;
      }

      if(jointPropertyValue?.fieldValue == "" || jointPropertyValue.toLocaleLowerCase() == "no"){
        contributionpercentage = 0;
        eligibleAmount = 0;
      }else{
         // if(letProperty?.fieldValue == "" ||letPropertyValue.toLocaleLowerCase() == "no"){
            eligibleAmount = (Number(interestPaidOnProperty * contributionpercentage)/100);
          // }else{
          //   eligibleAmount= (Number(interestPaidOnProperty * contributionpercentage)/100);
          // }
      }

      //  //console.log('eligibleamoutn value 2',eligibleAmount)


      //Formula
      //(Income from HP/Notional rent - Municipal taxes paid(If any)) * 30/100
      standardDeduction = (Number(incomeFromHpNotionalRent) - Number(municipalTaxesPaid)) * (30 / 100)

      //(Income from HP/Notional rent - Municipal taxes paid(If any)) - (Interest paid on property(upto limit of 200000) + (-)30% Standard deduction)
      incomeLossFromHp = ((Number(incomeFromHpNotionalRent) - Number(municipalTaxesPaid)) - (Number(interestPaidOnProperty) + Number(standardDeduction)));

     
      
      ////console.log("standardDeduction : " + standardDeduction);
      ////console.log("incomeLossFromHp : " + incomeLossFromHp);

      const fieldValues: Record<string, any> = {};

      const updatedCycleList = cycleList.map((cycle) => {
        // if (cycle.isCurrentCycle) {
          return {
            ...cycle,
            cycleDetails: cycle.cycleDetails.map((details) => {
              if (details.isAdditionalFieldFocused) {
                return {
                  ...details,
                  additionalFieldListV2: details.additionalFieldListV2.map((field, index) => {
                    const key = `${field.fieldName}-${field.id}-${index}`;
                    if (field.displayName === incomeFromHpNotionalRentFieldName && field.id === updatedId) {
                      fieldValues[key] = incomeFromHpNotionalRent;

                      return {
                        ...field,
                        fieldValue: String(incomeFromHpNotionalRent),
                      };
                    }
                    if (field.displayName === municipalTaxesPaidFieldName && field.id === updatedId) {
                      fieldValues[key] = municipalTaxesPaid;
                      return {
                        ...field,
                        fieldValue: String(municipalTaxesPaid),
                      };
                    }
                    if (field.displayName === interestPaidOnPropertyFieldName && field.id === updatedId) {
                      fieldValues[key] = interestPaidOnProperty;
                      return {
                        ...field,
                        fieldValue: String(interestPaidOnProperty),
                      };
                    }
                    if (field.displayName === standardDeductionFieldName && field.id === updatedId) {

                      fieldValues[key] = standardDeduction;

                      return {
                        ...field,
                        fieldValue: String(standardDeduction),
                      };
                    }
                    if (field.displayName === incomeLossFromHpFieldName && field.id === updatedId) {

                      fieldValues[key] = incomeLossFromHp;

                      return {
                        ...field,
                        fieldValue: String(incomeLossFromHp),
                      };
                    }
                    if (field.displayName === eligibleAmountFieldName && field.id === updatedId) {
                      ////console.log('inside eligible amount name ',eligibleAmount)
                      fieldValues[key] = eligibleAmount;

                      return {
                        ...field,
                        fieldValue: String(eligibleAmount),
                      };
                    }
                    return field;
                  }),
                };
              }
              return details;
            }),
          };
        // }
        // return cycle;
      });

      setCycleList(updatedCycleList);
      form.setFieldsValue(fieldValues);

      setChangedFieldName("");
      setChangedItemId(0);
    }

  }

  const BindInterestPaid = (currCycleList: any) => {

    const fieldValues: Record<string, any> = {};
    let updatedId = 0;
    let updatedamount = 0;
    const fieldName = "interest paid on property";
    const eligibleAmountField = "eligible amount";
    const contributionPercentageField = "self-contribution percentage";
    var contributionPercentagevalue = 0;
    var displayName = "";


    const updatedCycleList = currCycleList.map((cycle) => {
      // if (cycle.isCurrentCycle) {
        return {
          ...cycle,
          cycleDetails: cycle.cycleDetails.map((details) => {
            if (details.isAdditionalFieldFocused) {
              updatedamount = details.amount || 0;
              return {
                ...details,
                additionalFieldListV2: details.additionalFieldListV2.map((field, index) => {
                  const key = `${field.fieldName}-${field.id}-${index}`;


                  if (field.displayName.toLocaleLowerCase().includes(fieldName)) {   // && field.id === updatedId) {
                    displayName = field.displayName;
                    fieldValues[key] = updatedamount || 0;
                    updatedId = field.id;
                    return {
                      ...field,
                      fieldValue: String(updatedamount),
                    };
                  }
                 else if (field.displayName.toLowerCase() === eligibleAmountField) {
                      displayName = field.displayName;
                      const contibutionpercentage = details.additionalFieldListV2?.find((f)=>f.displayName.toLowerCase() == contributionPercentageField)
                     
                      contributionPercentagevalue = contibutionpercentage.fieldValue
                      const eligibleKey = `${field.fieldName}-${field.id}-${index}`;
                      const contributionShare = contributionPercentagevalue / 100;

                      // You’ll calculate eligible amount using logic like:
                      const eligibleAmount = updatedamount * contributionShare;

                      fieldValues[eligibleKey] = eligibleAmount;
                      updatedId = field.id;

                      return {
                        ...field,
                        fieldValue: String(eligibleAmount),
                      };
                    }

                  return field;
                }),
              };
            }
            return details;
          }),
        };
      // }
      // return cycle;
    });

    setChangedFieldName(displayName);
    setChangedItemId(updatedId);

    setCycleList(updatedCycleList);
    form.setFieldsValue(fieldValues);

  }
  // //console.log('startDateMap:', startDateMap);
  ////console.log('startDateMap[item.id]:', startDateMap[tem.id]);
  // //console.log('endDateMap:', endDateMap);


  const handleAction = async (type: any) => {
      confirm({
        content: "Are you sure you want to " + type.toLocaleLowerCase() + " ?",
        okText: 'Ok',
        cancelText: 'Cancel',
        onOk() {
          updateAction(type);
        },
        onCancel() {
        },
      });
    }
  
    const updateAction = async (type: any) => {
      //debugger;
      try {
  
        showLoader();
        if(type.toLowerCase() != "undo"){
        const validate = await form.validateFields();
        }

        //console.log('on approve click ',currentSelectedItem)
        //console.log('cyclelist approve click',cycleList)
        debugger;
        let updatedvalue = cycleList
          // ?.filter((item) => item.isCurrentCycle)
          ?.map((item) => ({
            //...item,
            cycleDetails: item.cycleDetails?.filter(
              (cycle) => cycle?.isAdditionalFieldFocused
            )
          }));

          console.log('updatedvalue',updatedvalue)
        //  let updatedindex = cycleList

        //   //?.find((item) => item?.isCurrentCycle)
        //   ?.cycleDetails
        //   ?.findIndex((detail)=> detail.isAdditionalFieldFocused)

        const updatedindex = cycleList
          ?.map((cycle, cycleIndex) => ({
            cycleIndex,
            detailIndex: cycle?.cycleDetails?.findIndex(
              detail => detail?.isAdditionalFieldFocused === true
            )
          }))
          ?.find(item => item.detailIndex !== -1);

          console.log('updatedindex',updatedindex)

        //console.log('updatedvalue -> ',updatedvalue)
       // let currentSelectedOuterRecord = updatedvalue[0].cycleDetails[0]

       const currentSelectedOuterRecord = updatedvalue
        ?.flatMap(cycle => cycle?.cycleDetails || [])
        ?.find(detail => detail?.isAdditionalFieldFocused === true);
        
        let idsString = currentSelectedOuterRecord?.employeeSubmissionFinalDetailsAdditionlFieldId;


        const idArray = idsString ? idsString.split(',').map(id => Number(id.trim())) : [];

        const additionalfields = currentSelectedOuterRecord?.additionalFieldListV2 || [];

        // let additionalfields = updatedvalue[0].cycleDetails[0].additionalFieldListV2
        // const transformedFields = additionalfields?.map((field) => ({
        //   key: field.fieldName,  // change to whatever property you want as the key
        //   value: field.fieldValue
        // })); 

        const allIds = new Set([
        ...idArray,
        ...additionalfields.map(field => Number(field.id))
      ]);

        console.log("allIds",allIds)
        console.log('additionalfields',additionalfields)
        const apiPayloads = Array.from(allIds).map(id => {
        const matchingFields = additionalfields
          .filter(field => Number(field.id) === id)
          .map(field => ({
            key: field.fieldName,
            value: field.fieldValue
          }));

        return {
          id,
          fields: matchingFields.length > 0 ? matchingFields : null
        };
      });

        //console.log('currentSelectedOuterRecord',currentSelectedOuterRecord)
        //console.log('additionalfields ',additionalfields)
        console.log("additionalfields apiPlayloads",apiPayloads)

        let ExecuteActionResponse;
        console.log('apiPayloads',apiPayloads)
        if(apiPayloads?.length>0){
          for (const payload of apiPayloads) {
             ExecuteActionResponse = await API.post(updateVerificationAction, {
              EmployeeSubmissionId: currentSelectedOuterRecord.employeeSubmissionId,
              EmployeeFinalSubmissionId: currentSelectedOuterRecord.employeeFinalSubmissionId,
              EmployeeSubmissionFinalDetailsAdditionalFieldMappingId: payload.id, // dynamic
              Action: type,
              CreatedBy: userId,
              Amount: currentSelectedOuterRecord.amount || null,
              DynamicList: payload.fields || [], // dynamic
              Remark: currentSelectedOuterRecord.remark || null,
              VerifierRemarks:currentSelectedOuterRecord.verifierRemarks || null  // or use currentSelectedOuterRecord.verifierRemark || null
            });

            //console.log("API Response for ID:", payload.id, ExecuteActionResponse);
          }
        }
        if(apiPayloads?.length == 0){
         
           ExecuteActionResponse = await API.post(updateVerificationAction, {
              EmployeeSubmissionId: currentSelectedOuterRecord.employeeSubmissionId,
              EmployeeFinalSubmissionId: currentSelectedOuterRecord.employeeFinalSubmissionId,
              EmployeeSubmissionFinalDetailsAdditionalFieldMappingId: 0, // dynamic
              Action: type,
              CreatedBy: userId,
              Amount: currentSelectedOuterRecord.amount || null,
              DynamicList: [], 
              Remark: currentSelectedOuterRecord.remark || null,
              VerifierRemarks: currentSelectedOuterRecord.verifierRemarks || null // or use currentSelectedOuterRecord.verifierRemark || null
            });

            //console.log("API Response for ID:", ExecuteActionResponse);
        }

        //console.log('after execution ExecuteActionResponse',ExecuteActionResponse)
        // let ExecuteActionResponse = await API.post(updateVerificationAction, {
        //   EmployeeSubmissionId: currentSelectedOuterRecord.employeeSubmissionId,
        //   EmployeeFinalSubmissionId: currentSelectedOuterRecord.employeeFinalSubmissionId,
        //   Action: type,
        //   CreatedBy: userId,
        //   Amount: currentSelectedOuterRecord.amount || null,
        //   DynamicList: transformedFields || [], //currentSelectedItem.dynamicList || [],
        //   Remark: currentSelectedOuterRecord.remark || null,
        //   VerifierRemarks: "Test Verifier Remark" //currentSelectedOuterRecord.verifierRemark || null,
        // });
  
        if (ExecuteActionResponse.data.status != 0) {
          message.error(`Something went wrong.`);
        } else {
          //message.success("Action completed successfully.");
          switch (type.toLowerCase()) {
            case 'approve':
              message.success(`Submission have been successfully approved.`)
              break;
            case 'reject':
              message.success(`Submission have been successfully rejected.`)
              break;
            case 'undo':
              message.success(`Actions have been successfully undone.`)
              setIsDisable(false);
              break;
            default:
              message.success(`Action completed successfully.`)
              break;
          }
         // getInvestmentCycle();
          setFocusedIndex(updatedindex);
          setActionPerformed(`${idsString}-${Date.now()}`);
        }
  
  
      }
      catch (error) {
        hideLoader();
        console.error("Error:", error);
        //console.error("Error:", error.response.data);
        //message.error(`Failed to perform data save`);
      } finally {
        hideLoader();
      }
    }

    const getQuery = async () => {
        //debugger;
        setIsOpen(true);
    
        const res = await API.post(getQueryOnChat, {
          UserId: requserId,//userId
          FinancialYearId: currentFinancialYearId,
          IsVerifier: true,
        })
    
        if (res.data.data.length > 0) {
          setQueryList(res?.data?.data);
          await markAsRead();
          setMsgCount(0);
        } else {
          setQueryList([])
        }
      }
  
      const markAsRead = async () => {
      
          const res = await API.post(updateIsReadFlagForEmp, {
            UserId: userId,
            FinancialYearId: currentFinancialYearId
          })
      
        }


  const handleSkip = async (type: any, index: any) => {
    //debugger;

   //console.log('on start handle skip cycle',cycleList)
    // //console.log('cycleList in handle skip',cycleList)
    // const itemIndex = cycleList.find((cycle)=> cycle.isCurrentCycle == true)?.cycleDetails?.findIndex((details)=> details?.isAdditionalFieldFocused == true)
    //  //console.log('current index',itemIndex)

   //  let nextPendingDetailIndex =  cycleList.find((cycle)=> cycle.isCurrentCycle == true)?.cycleDetails?.findIndex((details,index)=> index >itemIndex  && (details?.status == "Pending" || details?.status == "Pending Verification" || details?.status == "Draft") )
     // let currentUserfieldLength = cycleList.find((cycle)=> cycle.isCurrentCycle == true)?.cycleDetails?.length;
    // console.log('next pending details',nextPendingDetailIndex)
    //  ////console.log('current user data lenght ',currentUserfieldLength)
     //if(itemIndex+1 == currentUserfieldLength || (nextPendingDetailIndex == -1)){
      //let nextUserRecordId = cycleList.find((cycle)=> cycle.isCurrentCycle == true)?.cycleDetails?.[0]?.nextUserId;
      // let nextUserRecordId = cycleList?.cycleDetails?.[0]?.nextUserId;

      // ////console.log("record id next user",nextUserRecordId)
      //  if(nextUserRecordId !=null || nextUserRecordId !=0 ){
      //   setReqUserId(nextUserRecordId);
      //  }


       const nextUserRecordId = cycleList
        ?.flatMap(cycle => cycle?.cycleDetails || [])
        ?.find(detail => detail?.nextUserId !== null && detail?.nextUserId !== 0)
        ?.nextUserId;

      if (nextUserRecordId !== null && nextUserRecordId !== undefined && nextUserRecordId !== 0) {
        setReqUserId(nextUserRecordId);
      }

    //  }else{
    //    let nextPendingDetailData = cycleList.find((cycle)=> cycle.isCurrentCycle == true)?.cycleDetails?.find((details,index)=> index == nextPendingDetailIndex  && (details?.status == "Pending" || details?.status == "Pending Verification" || details?.status == "Draft") )
    //   //   ////console.log('next pending index',nextPendingDetailData)
    //     handleEdit(nextPendingDetailData,true,nextPendingDetailIndex);
    //  }
     


    // for (let j = itemIndex; j < cycleList.length; j++) {

    //   var items = cycleList[j].cycleDetails;

    //   // Find current index
    //   const currentIndex = items?.findIndex(
    //     (item: any) =>
    //       //item.Id === currentSelectedItem.Id &&
    //       item.investmentCycleId == currentSelectedItem.investmentCycleId &&
    //       item.employeeSubmissionId === currentSelectedItem.employeeSubmissionId &&
    //       item.employeeFinalSubmissionId === currentSelectedItem.employeeFinalSubmissionId
    //   );

    //   //Look for the next "pending" item after currentIndex
    //   for (let i = currentIndex + 1; i < items.length; i++) {
    //     if (items[i].status.toLocaleLowerCase() === "pending verification" ||
    //       items[i].status.toLocaleLowerCase() === "pending") { // Or another "pending" condition
    //       handleEdit(items[i]);
    //       break;
    //     }
    //   }

    //   if (currentIndex + 1 == items.length) {
    //     if (currentSelectedItem.nextUserId > 0) {
    //       setReqUserId(currentSelectedItem.nextUserId);
    //       break;
    //     }
    //     else {

    //     }
    //   }


      //getInvestmentCycle();
      // navigate("/VerificationDashboard", {
      //   state: { userId: currentSelectedItem.nextUserId },
      // });
      //}
    //}
  }



  return (
    <>
      <div>
         <div className="row">
          <div className="col-lg-12 ">
            <div className="pageName">
              <Title level={4}>
                {"Verification Dashboard"}
              </Title>
            </div>
          </div>
        </div>
          <div className="row">
                  <div className="col-lg-12 ">
                    <div className="pageName">
                      <Title level={4}>
                        {userName}
                      </Title>
                    </div>
                  </div>
          </div>
      <Card className="tabsEmpl">
        <Form form={form} layout="vertical" className="tabform">
          {cycleList?.some(cycle => cycle?.cycleDetails && cycle?.cycleDetails.length > 0) ?

            <>
              {isAdded && (
                <Row gutter={[16, 16]}>
                  <Col xs={24} sm={6} md={12} lg={6}>
                    <Card bordered={true} className=" cardby" >
                      <div className="accordianDetail">
                        <Collapse
                          defaultActiveKey={["1"]}
                          // onChange={onChange}
                          expandIconPosition={expandIconPosition}
                          items={collapsibleItems}
                          expandIcon={expandIcon}
                          activeKey={activeKeys}
                          onChange={handleCollapseChange}
                        />
                      </div>
                    </Card>
                  </Col>
                  <Col xs={24} sm={6} md={12} lg={6}>
                    <Card bordered={true} className=" cardby">
                      <Row gutter={16} className="p-0">

                        <Col xs={24} sm={24} md={24}>
                            {/* <Button className="me-3 createBtn" type="default">
                                Info
                              </Button> */}
                            <Button className="me-3 createBtn" type="default"
                               onClick={() => {
                              getQuery();
                               }}>
                             Message
                         </Button>        
                       </Col> 

                        <Col xs={24} sm={24} md={24}>
                          <FormInput
                            name={"amount"}
                            label={"Amount"}
                            rules={[
                              { required: "true", message: "Amount is required" },
                            ]}
                            placeholder={"Enter Amount"}
                            textArea={false}
                            inputType={"number"}
                            min={"0"}
                            onChange={(e: any) => {
                              handleOnchange(e, "amount");
                            }}
                            onKeyPress={(e) => {
                              const charCode = e.which ? e.which : e.keyCode;
                              const char = String.fromCharCode(charCode);

                              // Allow digits
                              if (/^\d$/.test(char)) {
                                return;
                              }
                              // // Allow only one dot
                              // if (char === "." && !e.currentTarget.value.includes(".")) {
                              //   return;
                              // }
                              // Block anything else (letters, symbols, negative sign)
                              e.preventDefault();
                            }}
                            disabled={isDisable}
                          />
                        </Col>

                        <Col xs={24} sm={24} md={24}>
                          {cycleList
                            // .filter((ele: any) => ele?.isCurrentCycle === true)
                            .map((cycle: any, cycleIndex: number) => {
                              return cycle?.cycleDetails?.map(
                                (subDetails: any, subIndex: number) => {
                                  if (subDetails?.isAdditionalFieldFocused) {
                                    let previousId: any = null;
                                    let IsCurrentRecordDisable = subDetails?.status == "Approved" || subDetails?.status=="Rejected"
                                   

                                    return subDetails?.additionalFieldListV2?.map(
                                      (item: any, index: any) => {

                                        const renderValue = renderNumericFields(
                                          item,
                                          subDetails.sectionName,
                                          subDetails.sectionSystemName,
                                          index
                                        );

                                        const showDivider = previousId !== null && previousId !== item.id;
                                        const showCheckBox = previousId !== null && previousId !== item.id;
                                        previousId = item.id;

                                        // //console.log('subDetails===>', subDetails,
                                        //   'item ==>',item
                                        // )
                                        return (
                                          <>
                                            {showDivider && (
                                              <>
                                                <Divider />
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                    marginBottom: 16, // Adds space below this section
                                                  }}
                                                >
                                                  { 
                                                   (!IsCurrentRecordDisable) &&
                                                    subDetails.sectionName ==
                                                      "House Rent Allowance" ? (
                                                      <Checkbox
                                                        disabled={IsCurrentRecordDisable}
                                                        key={item.id}
                                                        onChange={(e) =>
                                                          replicatePreviousFields(
                                                            item.id,
                                                            e.target.checked
                                                          )
                                                        }
                                                      >
                                                        Same as above
                                                      </Checkbox>
                                                    ) : (
                                                      <></>
                                                    )
                                                  }

                                                  {(subDetails?.status != "Approved" ||
                                                    subDetails?.status !=
                                                    "Rejected") &&
                                                    !IsCurrentRecordDisable && (
                                                      <>
                                                        <Col
                                                          lg={
                                                            subDetails.sectionName ==
                                                              "House Rent Allowance"
                                                              ? 8
                                                              : 24
                                                          }
                                                          style={{
                                                            textAlign: "right",
                                                          }}
                                                        >
                                                          <Button
                                                            className="btn-saveDraft me-3"
                                                            type="default"
                                                            onClick={(e: any) => {
                                                              handleRemove(item.id);
                                                            }}
                                                            icon={
                                                              <CloseCircleOutlined />
                                                            }
                                                          ></Button>
                                                        </Col>
                                                      </>
                                                    )}
                                                </div>
                                              </>
                                            )}
                                            {renderValue && (

                                              <Form.Item
                                                label={`${item?.displayName}`}
                                                name={`${item?.fieldName}-${item.id}-${index}`}
                                                rules={[
                                                  {
                                                    required: item?.isMandatory,
                                                    message: `${item?.displayName} is required`,
                                                  },
                                                  ...(item?.responseType?.toLowerCase() ===
                                                    "numeric"
                                                    ? [
                                                      {
                                                        type: "number" as "number",
                                                        message: `${item?.displayName} must be a number`,
                                                      } as Rule,
                                                    ]
                                                    : []),
                                                  ...(item?.displayName
                                                    ?.toLowerCase()
                                                    .includes("pan")
                                                    ? [
                                                      {
                                                        validator: (
                                                          _: any,
                                                          value: any
                                                        ) => {
                                                          if (!value)
                                                            return Promise.resolve();
                                                          const panRegex =
                                                            /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/i;
                                                          if (
                                                            panRegex.test(value)
                                                          )
                                                            return Promise.resolve();
                                                          return Promise.reject(
                                                            new Error(
                                                              "Please enter a valid PAN card number"
                                                            )
                                                          );
                                                        },
                                                      } as Rule,
                                                    ]
                                                    : []),

                                                 ...(item?.displayName?.toLowerCase().includes("contribution percentage")
                                                    ? [
                                                        {
                                                          validator: (_: any, value: any) => {
                                                            const self = subDetails?.additionalFieldListV2?.find(
                                                              (i) => i.displayName === 'Self-contribution Percentage'
                                                            )?.fieldValue;

                                                            const other = subDetails?.additionalFieldListV2?.find(
                                                              (i) => i.displayName === "Other's-contribution Percentage"
                                                            )?.fieldValue;

                                                            const sum = (Number(self) || 0) + (Number(other) || 0);

                                                            // If both values are filled and sum is exactly 100, it's valid
                                                            if ((self !== undefined && other !== undefined) && sum === 100) {
                                                              return Promise.resolve();
                                                            }

                                                            // If either one is not filled yet, don't show error (wait for full input)
                                                            if (!self || !other) {
                                                              return Promise.resolve();
                                                            }

                                                            // Show error only if both are filled and sum is NOT 100
                                                            return Promise.reject(
                                                              new Error("Self + Other's Contribution must equal 100%")
                                                            );
                                                          },
                                                        },
                                                      ]
                                                    : []),

                                                    
                                                ]}
                                              >
                                                {item?.responseType &&
                                                  item?.responseType.toLowerCase() ===
                                                  "numeric" && (
                                                    <InputNumber
                                                      value={item.fieldValue}
                                                      key={index}
                                                      onChange={(e) =>
                                                        handleAdditionalChange(
                                                          e,
                                                          "numeric",
                                                          item,
                                                          subDetails
                                                        )
                                                      }
                                                      placeholder={`Enter ${item?.displayName}`}
                                                      onKeyPress={(e) => {
                                                        const charCode = e.which ? e.which : e.keyCode;
                                                        const char = String.fromCharCode(charCode);

                                                        // Allow digits
                                                        if (/^\d$/.test(char)) {
                                                          return;
                                                        }
                                                        // // Allow only one dot
                                                        // if (char === "." && !e.currentTarget.value.includes(".")) {
                                                        //   return;
                                                        // }
                                                        // Block anything else (letters, symbols, negative sign)
                                                        e.preventDefault();
                                                      }}
                                                      style={{ width: "100%" }}
                                                      disabled={
                                                        IsCurrentRecordDisable ||
                                                        item?.displayName
                                                          .toLocaleLowerCase()
                                                          .includes(
                                                            "income/loss from hp"
                                                          ) ||
                                                        item?.displayName
                                                          .toLocaleLowerCase()
                                                          .includes(
                                                            "(-)30% standard deduction"
                                                          ) ||
                                                        item?.displayName
                                                          .toLocaleLowerCase()
                                                          .includes(
                                                            "interest paid on property"
                                                          ) ||
                                                         item?.displayName
                                                          .toLocaleLowerCase()
                                                          .includes(
                                                            "eligible amount"
                                                          )
                                                      }
                                                    />
                                                  )}

                                                {item?.responseType &&
                                                  item?.responseType.toLowerCase() ===
                                                  "text input" && (
                                                    <Input
                                                      maxLength={item.charLimit}
                                                      disabled={IsCurrentRecordDisable}
                                                      placeholder={`Enter ${item?.displayName}`}
                                                      key={index}
                                                      rows={2}
                                                      onChange={(e) =>
                                                        handleAdditionalChange(
                                                          e,
                                                          "textInput",
                                                          item,
                                                          subDetails
                                                        )
                                                      }
                                                    />
                                                  )}

                                                {item?.responseType &&
                                                  item?.responseType.toLowerCase() ===
                                                  "radio button" && (
                                                    <Radio.Group
                                                      key={index}
                                                      options={item?.choicesValues?.map(
                                                        (choice: string) => ({
                                                          label: choice,
                                                          value: choice,
                                                        })
                                                      )}
                                                      disabled={IsCurrentRecordDisable}
                                                      onChange={(e) =>
                                                        handleAdditionalChange(
                                                          e,
                                                          "radioButton",
                                                          item,
                                                          subDetails
                                                        )
                                                      }
                                                    />
                                                  )}

                                                {item?.responseType &&
                                                  item?.responseType.toLowerCase() ===
                                                  "choices" && (
                                                    <Checkbox.Group
                                                      key={index}
                                                      options={item?.choicesValues?.map(
                                                        (choice: string) => ({
                                                          label: choice,
                                                          value: choice,
                                                        })
                                                      )}
                                                      disabled={IsCurrentRecordDisable}
                                                      onChange={(e) =>
                                                        handleAdditionalChange(
                                                          e,
                                                          "choices",
                                                          item,
                                                          subDetails
                                                        )
                                                      }
                                                    />
                                                  )}

                                                {item?.responseType?.toLowerCase() ===
                                                  "date" && (
                                                    <DatePicker
                                                      style={{ width: "100%" }}
                                                      format="YYYY-MM-DD"
                                                      value={ 
                                                        item.displayName
                                                          .toLowerCase()
                                                          .includes("start") ||
                                                          item.displayName
                                                            .toLowerCase()
                                                            .includes("from")
                                                          ? startDateMap[item.id]
                                                          : endDateMap[item.id]
                                                      }
                                                      placeholder={`Select ${item?.displayName}`}
                                                      disabled={IsCurrentRecordDisable}
                                                      onChange={(date) => {

                                                        const isStart =
                                                          item.displayName
                                                            .toLowerCase()
                                                            .includes("start") ||
                                                          item.displayName
                                                            .toLowerCase()
                                                            .includes("from");
                                                        const key = item.id;

                                                        if (isStart) {
                                                          setStartDateMap((prev) => ({
                                                            ...prev,
                                                            [key]: date,
                                                          }));
                                                        } else {
                                                          setEndDateMap((prev) => ({
                                                            ...prev,
                                                            [key]: date,
                                                          }));
                                                        }
                                                        handleAdditionalChange(
                                                          date,
                                                          "date",
                                                          item,
                                                          subDetails
                                                        );
                                                      }}
                                                      disabledDate={(current) => {

                                                        if(subDetails?.sectionName?.toLowerCase() === "leave travel concessions or assistance")
                                                        {
                                                          const key = item.id;
                                                          const isStartDate =
                                                            (item.displayName.toLowerCase().includes("start") ||
                                                            item.displayName.toLowerCase().includes("from"));
                                                            if (!isStartDate) {
                                                                const start = startDateMap[key];
                                                                return (
                                                                  start &&
                                                                  current &&
                                                                  !current.isAfter(start, "day") 
                                                                );
                                                              }
                                                              
                                                          return false;
                                                        }
                                                        else 
                                                        {
                                                          const key = item.id;
                                                        
                                                          if (
                                                            item.displayName
                                                              .toLowerCase()
                                                              .includes("start") ||
                                                            item.displayName
                                                              .toLowerCase()
                                                              .includes("from")
                                                          ) {
                                                            const end = endDateMap[key];
                                                            return (
                                                              end &&
                                                              current &&
                                                              current.isAfter(
                                                                end,
                                                                "day"
                                                              )
                                                            );
                                                          } else {
                                                            const start =
                                                              startDateMap[key];
                                                            return (
                                                              start &&
                                                              current &&
                                                              current.isBefore(
                                                                start,
                                                                "day"
                                                              )
                                                            );
                                                          }

                                                        }
                                                        
                                                      }
                                                    
                                                    }
                                                    />
                                                  )}

                                                {item?.responseType?.toLowerCase() ===
                                                  "dropdown" && (
                                                    <Select
                                                      style={{ width: "100%" }}
                                                      disabled={IsCurrentRecordDisable}
                                                      placeholder={`Select ${item?.displayName}`}
                                                      onChange={(value) =>
                                                        handleAdditionalChange(
                                                          value,
                                                          "dropdown",
                                                          item,
                                                          subDetails
                                                        )
                                                      }
                                                    >
                                                      {item?.choicesValues?.map(
                                                        (choice: string) => (
                                                          <Select.Option
                                                            key={choice}
                                                            value={choice}
                                                          >
                                                            {choice}
                                                          </Select.Option>
                                                        )
                                                      )}
                                                    </Select>
                                                  )}
                                              </Form.Item>
                                              // </Col>
                                            )}
                                          </>
                                        );
                                      }
                                    );
                                  }
                                  return null;
                                }
                              );
                            })}
                        </Col>

                        <Col xs={24} sm={24} md={24}>
                          { (!isDisable) && isReplicable && sectionName == "House Rent Allowance" ? (
                            <Button
                              type="default"
                              className="btn-viewsub me-3"
                              disabled={isDisable}
                              onClick={() => handleReplicate()}
                            >
                              {"Add Landlord"}
                            </Button>
                          ) : (
                            isReplicable && (!isDisable) && (
                              <Button
                                type="default"
                                className="btn-viewsub me-3"
                                disabled={isDisable}
                                onClick={() => handleReplicate()}
                              >
                                {"Add"}
                              </Button>
                            )
                          )}
                        </Col>

                        <Col xs={24} sm={24} md={24}>
                          <FormInput
                            name={"remark"}
                            label={"Remark"}
                            placeholder={"Enter Remark"}
                            rules={[
                              { required: true, message: "Remark is required" },
                            ]}
                            disabled={isDisable}
                            textArea={true}
                            onChange={(e: any) => {
                              handleOnchange(e, "remark");
                            }}
                          />
                        </Col>
                        
                      {/* {
                        isShowVerifier && */}
                        <Col xs={24} sm={24} md={24}>
                          <FormInput
                            name={"verifierRemark"}
                            label={"VerifierRemark"}
                            rules={[
                              { required: true, message: "Verifier remark is required" },
                            ]}
                            placeholder={"Enter Verifier Remark"}
                            disabled={isDisable}
                            textArea={true}
                            onChange={(e: any) => {
                              handleOnchange(e, "verifierRemark");
                            }}
                          />
                        </Col>
                      {/* } */}


                       <Col xs={24} sm={24} md={24}>
                                            {currentSelectedItem &&  //currentSelectedItem?.pendingWithUserId &&
                                              (currentSelectedItem?.pendingWithUserId == userId || isCurrUserAdminOrSuperAdmin) &&
                                              (
                                                <>
                                                  { ( (!isDisable) || isApprovedOrRejected)&& (
                                                      <>
                                                        <Button className="me-3 btn-viewsub" type="default"
                                                          onClick={() => {
                                                            handleAction("Approve");
                                                          }}>
                                                          Approve
                                                        </Button>
                                                        <Button className="lock me-3" type="default"
                                                          onClick={() => {
                                                            handleAction("Reject");
                                                          }}>
                                                          Reject
                                                        </Button>
                                                      </>
                                                    )}
                      
                                                  <Button className="btn-skip mt-2 me-3" type="default"
                                                    onClick={() => {
                                                      //handleAction("Skip");
                                                      handleSkip("Skip", 0);
                                                    }}>
                                                    Skip
                                                  </Button>
                                                  { (isDisable || isUndoButtonVisible) && (
                                                      <>
                                                        <Button className="mt-2 me-3 createBtn" type="default"
                                                          onClick={() => {
                                                            handleAction("Undo");
                                                          }}>
                                                          Undo
                                                        </Button>
                                                      </>
                                                    )}
                                                </>
                                              )} 
                                          </Col>
                         

                      </Row>
                    </Card>
                  </Col>

                  <Col xs={24} sm={12} md={24} lg={12}>
                    <Card bordered={true} className="p-0 pdfView">
                      <div style={{ maxWidth: "900px", margin: "auto" }}>
                        <div
                          style={{
                            border: "1px solid #ddd",
                            overflow: "auto",
                          }}
                          className="pdfBox"
                        >
                          {fileType === "pdf" && <PdfViewer key={viewerKey+1} base64={fileBase64} />}
                          {fileType === "image" && (
                            <ImageViewer base64={fileBase64} />
                          )}
                        </div>
                      </div>
                    </Card>
                  </Col>

                {isOpen &&
                <>
                  <Flex vertical gap="middle" align="flex-start">
                    <Modal
                      title="Message List"
                      centered
                      open={isOpen}
                      onCancel={() => setIsOpen(false)}
                      footer={false}
                      width={{
                        xs: '80%',
                        sm: '80%',
                        md: '80%',
                        lg: '40%',
                        xl: '50%',
                        xxl: '50%',
                      }}  >
                      {/* <hr style={{ border: "1px solid var(--dark-color)" }}></hr> */}
                      <div className="messageList">
                        <ChatBox message={queryList} touserid={requserId} type={"Verifier"} />
                        {/* {queryList && queryList.map((ele: any) => {
                            return (<>
                              <Card onClick={() => { innerModal(ele) }}>
                                <div className='Message'>
                                  <div className='d-flex w-100 align-items-flex-center justify-content-start  '>
                                    <div className='w-49'><h5>Employee Name :</h5> <span>{ele?.employeeName}</span></div>
                                    <div className='w-49'><h5>Employee Code :</h5> <span>{ele?.employeeCode}</span></div>
                                  </div>
                                  <div className='d-flex w-100 align-items-flex-center justify-content-start  '>
                                    <h5>Message :</h5> <span>{ele?.message}</span>
                                  </div>
                                </div>
                              </Card>

                            </>)
                          })} */}

                      </div>
                    </Modal>
                  </Flex>

                </>
              }

                </Row>
              )}
            </>

            :
            <></>

          }

        </Form>
      </Card>
      </div>
    </>
  );
};

export default VerificationDashboard;
